// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T23:01:33.865Z
// Property: Cloverset Valley Apartments (ID: 6767906449167593)
// Collections: 24 amenities, 5 floorplans (live), 31 photos, 75 POIs, 2 reviews, 5 virtual tours, 6 office hours, 16 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162465",
  "multihub_property_id": "6767906449167593",
  "property_external_id": "1124087",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/cloverset-active-adult-apartments-kansas-city-mo/v0s93sg/",
  "property_google_business_url": "https://www.google.com/maps/place/Cloverset+Apartment+Homes/@38.9359138,-94.5989706,890m/data=!3m2!1e3!4b1!4m6!3m5!1s0x87c0e85421203f53:0x92b6fd945d143189!8m2!3d38.9359138!4d-94.5989706!16s%2Fg%2F11cmzh1wjb?entry=ttu&g_ep=EgoyMDI2MDkwOS4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "1124087 p1099039",
  "property_status": null,
  "property_slug": "cloverset-valley-apartments",
  "property_name": "Cloverset Valley Apartments",
  "property_website_url": "https://www.cloversetapts.com/",
  "property_domain": "https://www.cloversetapts.com/",
  "property_address": "10601 Jefferson St",
  "property_full_address": "10601 Jefferson St, Kansas City, MO 64114",
  "property_address_1": "10601 Jefferson St",
  "property_address_2": null,
  "property_address_city": "Kansas City",
  "property_address_state": "MO",
  "property_address_zip_full": null,
  "property_address_zip": "64114",
  "property_address_country": "US",
  "property_address_county": "Jackson County",
  "property_neighborhood_address": "Country Lane Estates",
  "property_address_latitude": "38.93581770000001",
  "property_address_longitude": "-94.59791609999999",
  "property_email": "rentcafe.cs@pricekc.com",
  "property_phone": "(816) 323-4680",
  "property_call_tracking_phone": "816-323-4680",
  "property_company_name": "Price Brothers",
  "property_company_url": "https://www.pricebrotherskc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Settle into a quieter South Kansas City rhythm.</strong> Cloverset Valley pairs landscaped, gated grounds with spacious one- and two-bedroom layouts, private balconies, large kitchens, and everyday conveniences close by—schedule a tour to see the space for yourself.</p>",
  "property_long_description": "<p>Cloverset Valley gives you more time for what you enjoy and less time spent on upkeep. Our one- and two-bedroom 55+ apartments feature large kitchens, wood-burning fireplaces, private balconies, and spacious closets, with select homes offering updated finishes, a separate dining space, or a den.</p><p>Around the community, the clubhouse is a natural place to catch up with neighbors, while the fitness center, swimming pool with sun deck and cabana, and tennis court make it easy to stay active. Elevators in every building, controlled-access entries, garage parking below, and laundry facilities on every floor keep everyday routines simple.</p><p>Cloverset Valley has been part of Kansas City’s active adult community since 1981, and we’d love for you to see what makes it feel like home.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101d-9bc1-724e-a778-0c6043a098fc.webp",
  "property_featured_image_media": {
    "alt_text": "Modern living and dining area with a white table and chairs, a sofa, and two accent chairs.",
    "public_id": "01a0101d-9bc1-724e-a778-0c6043a098fc",
    "storage_key": "property/6767906449167593/01a0101d-9bc1-724e-a778-0c6043a098fc.webp",
    "width": 1200,
    "height": 800
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "258",
  "property_year_built": "1981",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.96124031007753",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $175-275",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.",
  "property_pet_policy_description": "The non-refundable fee is $300 for 1 pet, and $500 for 2 pets.",
  "property_petpolicy_info": "https://www.pricebrotherskc.com/petroyaltyclub/",
  "property_online_leasing_url": "https://cloversetapts.securecafeapplicant.com/onlineleasing/content3/access/cloverset/floorplans",
  "property_resident_portal_url": "https://cloversetapts.securecafe.com/residentservices/cloverset/userlogin.aspx",
  "property_apply_now_url": "https://cloversetapts.securecafeapplicant.com/onlineleasing/content3/access/cloverset/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc928-58e0-72ef-99c9-ce96b935207f.webp",
  "property_primary_logo_media": {
    "alt_text": "Cloverset Active Adult Apartments logo",
    "public_id": "019fc928-58e0-72ef-99c9-ce96b935207f",
    "storage_key": "property/6767906449167593/019fc928-58e0-72ef-99c9-ce96b935207f.webp",
    "width": 1200,
    "height": 375
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc928-eb64-76d4-95fc-f680748bbf63.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019fc928-eb64-76d4-95fc-f680748bbf63",
    "storage_key": "property/6767906449167593/019fc928-eb64-76d4-95fc-f680748bbf63.webp",
    "width": 1200,
    "height": 375
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc928-dde3-7398-a4db-3350161f9b85.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019fc928-dde3-7398-a4db-3350161f9b85",
    "storage_key": "property/6767906449167593/019fc928-dde3-7398-a4db-3350161f9b85.webp",
    "width": 1200,
    "height": 375
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a0d9b7-62d2-753a-a137-bd690ff6733b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff68a-de80-741a-9687-3e84c8c517e3.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#3E5063",
  "property_secondary_color": "#BC934D",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#974733",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "760 - 1420",
  "property_sqft_min": "760",
  "property_sqft_max": "1420",
  "property_price_range": "1176 - 5384",
  "property_price_min": "1176",
  "property_price_max": "5384",
  "property_available_units": 13,
  "property_facebook_url": "https://www.facebook.com/CloversetApts/",
  "property_instagram_url": "https://www.instagram.com/cloversetapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJUz8gIVTowIcRiTEUXZT9tpI",
  "property_youtube_url": "https://www.youtube.com/user/Pricebrothersmgt",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Cloverset Valley Apartments",
  "property_home_romance_title": "Embrace Life at Your Dream Apartment Community Today!",
  "property_home_amenities_blurb": "<p><strong>Comfort comes standard at Cloverset Valley.</strong> Gated access, elevators, 24-hour emergency maintenance, and laundry on every floor help simplify the day, while the clubhouse with Wi-Fi adds space to unwind. Recharge at the fitness center, tennis court, or swimming pool with sun deck and cabana, then come home to a large kitchen, spacious closets, private balcony, and wood-burning fireplace. Select apartments feature refreshed finishes like plank flooring, stainless steel appliances, upgraded counters, and modern lighting.</p>",
  "property_home_floorplans_blurb": "<p><strong>One- and two-bedroom layouts with room to settle in.</strong> Cloverset Valley floor plans pair everyday function with standout comforts, including large kitchens, generous closets, private balconies, and wood-burning fireplaces. Select apartments add plank flooring, stainless steel appliances, upgraded counters, modern lighting, spacious showers, or a den/study—giving each home its own easy sense of flexibility.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture life at Cloverset Valley.</strong> Preview bright living rooms with wood-burning fireplaces, roomy kitchens, dining nooks, spacious closets, and balconies that open your home to the outdoors. Then explore community scenes featuring the pool and sun deck, cabana, clubhouse with Wi-Fi, fitness center, tennis court, and landscaped Country Lane Estates setting.</p>",
  "property_home_neighborhood_blurb": "<p>Cloverset Valley sits in a quiet part of South Kansas City, just off Wornall Road and a short way east of State Line Road and the Leawood border. I-435 is close by, connecting you to US-71, Johnson County, and destinations across the metro.</p><p>St. Joseph Medical Center is just around the corner, and Watts Mill Plaza is right down the road for everyday errands. For fresh air, the Indian Creek Trail and Minor Park along the Blue River offer plenty of room to walk and explore.</p><p>Visit our <a href=\"/neighborhood\">Neighborhood page</a> to see more of South Kansas City.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents praise the easygoing feel at Cloverset Valley Apartments.</strong> Reviews often mention attentive staff, quick service follow-through, clean surroundings, and a calm smaller-community setting. With everyday conveniences close by and a friendly atmosphere throughout the property, Cloverset Valley earns high marks for comfort, care, and a place that feels easy to call home.</p>",
  "property_neighborhood_blurb": "<p>Cloverset Valley is located in South Kansas City, MO 64114, just off Wornall Road near I-435 and a short drive from Leawood and Johnson County.</p><p>Cloverset Valley is close to several medical centers. St. Joseph Medical Center is right around the corner, and a University of Kansas Health System medical pavilion is about a mile away.</p><p>Looking for a place to eat near Cloverset Valley? Local favorites include Jasper’s for Italian, Gates Bar-B-Q for Kansas City barbecue, Chick Bo-Bao, and McLain’s Market for coffee and baked goods. Rye in Leawood is a short drive away for a sit-down dinner.</p><p>Everyday errands are simple, too. Watts Mill Plaza, home to Cosentino’s Price Chopper and local restaurants, is just down the road, and a QuikTrip is nearby for gas and quick stops. Red Bridge Shopping Center and the Mid-Continent Public Library Red Bridge Branch are a short drive southeast, and Ward Parkway Center, with Trader Joe’s and Target nearby, is an easy drive north.</p><p>For time outdoors, Watts Mill Park and the Indian Creek Trail are close for daily walks, and Minor Park along the Blue River is a short drive away.</p><p>Explore the neighborhood map above to find more destinations near Cloverset Valley.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Cloverset Valley is an active adult community in Kansas City with a full calendar of resident events, including craft gatherings, movie nights, bingo, mahjong, and wine nights. The clubhouse with Wi-Fi is where neighbors gather and plans get made. The swimming pool, sundeck, and cabana fill summer afternoons, and the tennis court and fitness center keep everyone moving.</p><p>Low-maintenance living is part of the lifestyle. Every building at Cloverset Valley has an elevator, controlled-access entry, a parking garage below, and laundry facilities on every floor. Cloverset Valley is a smoke-free community with 24-hour emergency maintenance, so a leaky faucet is a phone call, not a weekend project.</p><p>Inside, every one- and two-bedroom apartment has a large kitchen, a wood-burning fireplace, spacious closets, and a private balcony.</p><p>Browse the complete list of community and apartment amenities above.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Cloverset Valley Apartments home?</strong><br>Start your online application for a quieter South Kansas City address with comfortable one- and two-bedroom <a href=\"/floor-plans\">floor plans</a>, landscaped grounds, gated access, and everyday conveniences designed to keep life calm, connected, and effortless.</p>",
  "property_contactus_blurb": "<p>Have questions about <a href=\"/floor-plans\">floor plans</a>, garage parking, or what life is like at Cloverset Valley? Our leasing team is happy to help with current availability, lease options, pets, and community amenities.</p><p>Call us, stop by the leasing office, or send a message using the form above. We look forward to getting to know you.</p>",
  "property_faqs_blurb": "<p>Find information about applying, lease terms, pets, parking, utilities, and resident services at Cloverset Valley.</p><p>Still have questions? The Cloverset Valley <a href=\"/contact-us\">leasing team</a> is always glad to help.</p>",
  "property_floorplans_blurb": "<p>Cloverset Valley offers one- and two-bedroom 55+ apartments with room for hobbies, overnight guests, or a home office. Downsizing from a house doesn’t have to mean giving up space.</p><p>Every apartment includes a large kitchen, a wood-burning fireplace, a private balcony, spacious closets, and extra storage. Select homes add stainless steel appliances, upgraded counters and lighting, plank flooring, a large walk-in shower, a separate dining space, or a den or study. Every Cloverset Valley building has an elevator and laundry facilities on each floor.</p><p>Browse available floor plans above, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite in person.</p>",
  "property_gallery_blurb": "<p>Get a feel for life at Cloverset Valley before you visit. The gallery shows apartment interiors with spacious bedrooms, dining areas, and updated kitchens, along with the swimming pool and cabana, the clubhouse, the fitness center, and the grounds.</p><p>There’s nothing like seeing it in person. <a href=\"/schedule-a-tour\">Schedule a tour</a> of Cloverset Valley.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore a calm, connected South Kansas City address.</strong> Use the interactive map to view available apartments at Cloverset Valley and see how Country Lane Estates puts everyday errands, parks, shopping, and I-435 access within easy reach.</p>",
  "property_pets_blurb": "<p>Cloverset Valley offers pet-friendly 55+ apartments in Kansas City, because a dog or cat is often part of the family. Every pet owner at Cloverset Valley joins the <a href=\"https://www.pricebrotherskc.com/petroyaltyclub/\" target=\"_blank\">Price Brothers Pet Royalty Club</a> with the one-time pet fee, which includes discounts at local pet businesses across Kansas City.</p><p>Up to two dogs or cats are allowed per apartment. Monthly pet rent is $25 per pet, and the non-refundable pet fee is $300 for one pet or $500 for two pets. Restricted breeds include Pit Bulls, American Staffordshire Terriers, Rottweilers, German Shepherds, Malamutes, Doberman Pinschers, Chows, Great Danes, Saint Bernards, Akitas, wolf hybrids, and mixes of these breeds.</p><p><a href=\"/contact-us\">Contact the Cloverset Valley leasing team</a> for complete pet guidelines.</p>",
  "property_referafriend_blurb": "<p><strong>Share the calm, connected Cloverset Valley lifestyle.</strong> If landscaped grounds, gated access, spacious floor plans, and easy days by the pool are part of what makes home feel effortless, invite a friend to experience it too. Send a referral and help them discover apartment living in South Kansas City.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Cloverset Valley.</strong><br>Keep everyday living effortless from your calm, connected South Kansas City address. Log in to pay rent, submit maintenance requests, and manage your account—then get back to enjoying the landscaped grounds, clubhouse, and comfortable apartment spaces you call home.</p>",
  "property_reviews_blurb": "<p><strong>See what residents are saying about Cloverset Valley Apartments.</strong> Reviews point to a community that feels easy to settle into, with attentive staff, prompt follow-through on service requests, and a calm setting that residents appreciate day to day.</p><p>Longtime and newer residents alike highlight the smaller-complex feel, clean surroundings, and friendly atmosphere. One resident shares, “I can truly call this place home,” while another notes that when something needs attention, it is “usually done fairly quickly.” You’ll also see praise for convenient access to nearby everyday stops, making Cloverset Valley a place where comfort, care, and practical convenience come together.</p>",
  "property_created_at": "1785786244733",
  "property_scheduletour_blurb": "<p>Comparing 55+ communities in Kansas City? The best way to find the right fit is to visit. Schedule a guided tour to explore available <a href=\"/floor-plans\">floor plans</a>, see the clubhouse and pool, and ask about garage parking.</p><p>Our leasing team will be glad to answer your questions along the way. Choose a time above to plan your visit.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong><br>The Cloverset Valley leasing team will be in touch soon. In the meantime, picture a quieter South Kansas City setting with comfortable one- and two-bedroom layouts, landscaped grounds, and everyday conveniences that make coming home feel effortless.</p>",
  "property_virtualtours_blurb": "<p>Take a look inside Cloverset Valley from the comfort of home. Our virtual tours walk you through our one- and two-bedroom floor plans so you can get a feel for the space and layout before you visit.</p><p>Look for large kitchens, fireplaces, and private balconies as you explore each home.</p><p>Ready for a closer look? <a href=\"/schedule-a-tour\">Schedule a tour</a> or <a href=\"/floor-plans\">compare floor plans</a> to take the next step.</p>",
  "property_copyright": "2026 All Rights Reserved. Cloverset Valley Apartments",
  "property_seo_title_home": "Cloverset Valley | 55 Plus Communities Kansas City, MO",
  "property_seo_description_home": "Cloverset Valley offers 55+ apartments in Kansas City, MO with spacious homes, inviting amenities, and a convenient location. Schedule your tour today.",
  "property_seo_title_floorplans": "Floor Plans | 1 & 2 Bedroom 55+ Communities Kansas City",
  "property_seo_description_floorplans": "Explore 1 and 2 bedroom 55+ apartments in Kansas City at Cloverset Valley, with spacious floor plans and top amenities.",
  "property_seo_title_amenities": "Amenities | Active Adult Community in Kansas City",
  "property_seo_description_amenities": "Discover Cloverset Valley, an active adult community in Kansas City with a pool, fitness center, clubhouse, tennis court, and garage parking below.",
  "property_seo_title_gallery": "Gallery | 55+ Apartment Communities in Kansas City",
  "property_seo_description_gallery": "Browse photos of Cloverset Valley, a 55+ apartment community in Kansas City, MO, featuring spacious homes, a swimming pool, clubhouse, and more.",
  "property_seo_title_virtualtours": "Virtual Tours | Apartments in South Kansas City, MO",
  "property_seo_description_virtualtours": "Take a virtual tour of Cloverset Valley in Kansas City, MO and explore our 1 and 2 bedroom 55+ apartment floor plans online before you visit.",
  "property_seo_title_interactivemap": "Interactive Map | Cloverset Valley Apartments Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Cloverset Valley Apartments in Kansas City! Check out our map for 1 & 2 bedroom layouts and amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in South Kansas City, MO",
  "property_seo_description_neighborhood": "Cloverset Valley offers apartments in South Kansas City, MO near Watts Mill Plaza, St. Joseph Medical Center, Indian Creek Trail, and Ward Parkway Center.",
  "property_seo_title_contact": "Contact Us | 55+ Apartments in South Kansas City",
  "property_seo_description_contact": "Contact Cloverset Valley in Kansas City, MO. Call or send a message to ask about availability, tours, and garage parking.",
  "property_seo_title_faqs": "FAQs | Cloverset Valley 55+ Apartments in Kansas City",
  "property_seo_description_faqs": "Get answers about applying, pets, parking, utilities, and more at Cloverset Valley, 55+ apartments in South Kansas City, MO.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Kansas City, MO",
  "property_seo_description_reviews": "Discover Cloverset Valley Apartments in Kansas City, MO! Read resident reviews and see why our spacious homes and amenities are so loved!",
  "property_seo_title_applynow": "Apply Now | Apartments in Kansas City, MO",
  "property_seo_description_applynow": "Discover Cloverset Valley Apartments in Kansas City! Spacious layouts, modern amenities, and a vibrant community await. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Cloverset Valley Apartments",
  "property_seo_description_residentaccess": "Login to Cloverset Valley Apartments' resident portal for easy rent payments, maintenance requests, and community updates—all from the comfort of your home!",
  "property_seo_title_referafriend": "Refer A Friend | Cloverset Valley Apartments",
  "property_seo_description_referafriend": "Refer a friend to Cloverset Valley Apartments in Kansas City, MO! Great friends make great neighbors—share the charm of our community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | 55 and Older Communities Kansas City",
  "property_seo_description_scheduletour": "Comparing 55 and older communities in Kansas City? Tour Cloverset Valley to see our 1 and 2 bedroom floor plans, clubhouse, pool, and fitness center.",
  "property_seo_title_privacy": "Privacy Policy | Cloverset Valley Apartments",
  "property_seo_description_privacy": "At Cloverset Valley Apartments in Kansas City, MO, your privacy matters. Uncover how we protect your information with our comprehensive privacy policy.",
  "property_seo_title_accessibility": "Website Accessibility | Cloverset Valley Apartments",
  "property_seo_description_accessibility": "At Cloverset Valley Apartments in Kansas City, we prioritize accessibility for all. Experience a community where everyone feels at home. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Cloverset Valley Apartments",
  "property_seo_description_sitemap": "Uncover the layout of Cloverset Valley Apartments in Kansas City, MO. Navigate easily with our sitemap and find your ideal home today!",
  "property_seo_title_thankyou": "Thank You | Cloverset Valley Apartments",
  "property_seo_description_thankyou": "Thank you for your interest in Cloverset Valley Apartments in Kansas City! Our team will reach out soon to help you find your dream home.",
  "property_seo_title_pets": "Pet Policy | Pet-Friendly 55+ Apartments Kansas City",
  "property_seo_description_pets": "Find pet-friendly 55+ apartments in Kansas City at Cloverset Valley, with Price Brothers Pet Royalty Club perks for pets. View our full pet policy.",
  "property_updated_at": "1793742961827",
  "amenities": [
    {
      "id": "ec_8ce1be4174c763cc9f5a0b18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "yardi",
      "external_id": "87989747",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101d-aa36-7139-ba70-cbd66de058c7.webp",
      "amenity_image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, recumbent bikes, and weights.",
        "public_id": "01a0101d-aa36-7139-ba70-cbd66de058c7",
        "storage_key": "property/6767906449167593/01a0101d-aa36-7139-ba70-cbd66de058c7.webp",
        "width": 1200,
        "height": 801
      },
      "amenity_image_alt_text": "Bright Gym at Cloverset Active Adult Apartments, Kansas City,Gym with modern equipments at Cloverset Active Adult Apartments, Kansas City, MO",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_490a11fed0253057d6fd975a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "yardi",
      "external_id": "87989744",
      "title": "Controlled Access Buildings with a Parking Garage Below",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0626053b9bcde3f58d19d6b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "yardi",
      "external_id": "87989745",
      "title": "Elevator in Every Building",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3350599c41cfe829dee3b93f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "yardi",
      "external_id": "88008962",
      "title": "Laundry Facilities on Every Floor",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101d-aac0-76ba-be6b-95d764137713.webp",
      "amenity_image_media": {
        "alt_text": "Two commercial washing machines and dryers in a laundry room",
        "public_id": "01a0101d-aac0-76ba-be6b-95d764137713",
        "storage_key": "property/6767906449167593/01a0101d-aac0-76ba-be6b-95d764137713.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Small Laundry room at Cloverset Active Adult Apartments, Missouri",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ae58c6c67a155f930e843066",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "yardi",
      "external_id": "87989743",
      "title": "Clubhouse with Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101d-ab25-76de-9e06-dca7eeabe940.webp",
      "amenity_image_media": {
        "alt_text": "Community lounge area with tables and chairs.",
        "public_id": "01a0101d-ab25-76de-9e06-dca7eeabe940",
        "storage_key": "property/6767906449167593/01a0101d-ab25-76de-9e06-dca7eeabe940.webp",
        "width": 1200,
        "height": 799
      },
      "amenity_image_alt_text": "Bright and Modern Dining Area at Cloverset Active Adult Apartments, Kansas City, MO, 64114,Bright Living room at Cloverset Active Adult Apartments, Missouri, 64114",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d20b2ea293a441b91cdefe84",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "yardi",
      "external_id": "87989742",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_74160e53306b78c426e9585c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "yardi",
      "external_id": "124909602",
      "title": "Swimming Pool with Sun Deck & Cabana",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101d-ac49-7036-b3b8-25a061050e84.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "01a0101d-ac49-7036-b3b8-25a061050e84",
        "storage_key": "property/6767906449167593/01a0101d-ac49-7036-b3b8-25a061050e84.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Lounge chairs by the pool at Cloverset Active Adult Apartments, Kansas City, Missouri,Outdoor swimming pool view at Cloverset Active Adult Apartments, Kansas City, 64114,Pool side patio at Cloverset Active Adult Apartments, Kansas City",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3ae54b2a4e8b22fedbc7208d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "yardi",
      "external_id": "89142022",
      "title": "Tennis Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101d-ae50-746a-98b6-b183f310915a.webp",
      "amenity_image_media": {
        "alt_text": "Blue tennis court with green surrounding area and apartment buildings in the background.",
        "public_id": "01a0101d-ae50-746a-98b6-b183f310915a",
        "storage_key": "property/6767906449167593/01a0101d-ae50-746a-98b6-b183f310915a.webp",
        "width": 1800,
        "height": 1200
      },
      "amenity_image_alt_text": "Pickleball at Cloverset Active Adult Apartments, Kansas City, MO",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a1985ed00996d1e5dd20811f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "yardi",
      "external_id": "120549853",
      "title": "Smoke Free Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1bf63b55d12d0894960b506a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "yardi",
      "external_id": "87989754",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dcd36325bb22169b9a338fd4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "yardi",
      "external_id": "87989756",
      "title": "Laundry Facility On Every Floor",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101d-aac0-76ba-be6b-95d764137713.webp",
      "amenity_image_media": {
        "alt_text": "Two commercial washing machines and dryers in a laundry room",
        "public_id": "01a0101d-aac0-76ba-be6b-95d764137713",
        "storage_key": "property/6767906449167593/01a0101d-aac0-76ba-be6b-95d764137713.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Small Laundry room with machines at Cloverset Active Adult Apartments, Kansas City, 64114",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_824a0fe757fdbd5c9ef9170d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "yardi",
      "external_id": "87989755",
      "title": "Large Kitchens",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c011bee6d2c8ee9be58de308",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "yardi",
      "external_id": "87989758",
      "title": "Private Balconies",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101d-e438-75ff-a351-f3ebd21b3a92.webp",
      "amenity_image_media": {
        "alt_text": "View from balcony overlooking a swimming pool and apartment buildings on a sunny day.",
        "public_id": "01a0101d-e438-75ff-a351-f3ebd21b3a92",
        "storage_key": "property/6767906449167593/01a0101d-e438-75ff-a351-f3ebd21b3a92.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "Balcony at Cloverset Active Adult Apartments, Kansas City, Missouri",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ed6219a214f5242ce954689c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "yardi",
      "external_id": "87989764",
      "title": "Wood Burning Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101d-cbf4-71a8-ba37-acdff32e0741.webp",
      "amenity_image_media": {
        "alt_text": "A staged living and dining room area with a fireplace and balcony access.",
        "public_id": "01a0101d-cbf4-71a8-ba37-acdff32e0741",
        "storage_key": "property/6767906449167593/01a0101d-cbf4-71a8-ba37-acdff32e0741.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Living room with attached balcony at Cloverset Active Adult Apartments, Missouri",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fc006e4df62074263476b3e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "yardi",
      "external_id": "87989760",
      "title": "Spacious Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2486753646dfc605ce5106b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "yardi",
      "external_id": "87989759",
      "title": "Separate Dining Space*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b4dc1c36f68716c8308afb79",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "yardi",
      "external_id": "87989761",
      "title": "Stainless Steel Appliances*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101d-c04f-7145-bfd5-0f3319d0e7a4.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, stainless steel appliances, and quartz countertops.",
        "public_id": "01a0101d-c04f-7145-bfd5-0f3319d0e7a4",
        "storage_key": "property/6767906449167593/01a0101d-c04f-7145-bfd5-0f3319d0e7a4.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Kitchen with stove top oven at Cloverset Active Adult Apartments, Missouri, 64114",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1db5abf0fc38aaff3e3a0c82",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "yardi",
      "external_id": "87989757",
      "title": "Microwave*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_84001dafdfe432b366839722",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "yardi",
      "external_id": "87989753",
      "title": "Den/Study*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_49b6f278f8ae6bf59a7c16f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "yardi",
      "external_id": "87989763",
      "title": "Large Showers*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101d-c0a1-74bd-b502-9d5f5f79bc7c.webp",
      "amenity_image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and shower.",
        "public_id": "01a0101d-c0a1-74bd-b502-9d5f5f79bc7c",
        "storage_key": "property/6767906449167593/01a0101d-c0a1-74bd-b502-9d5f5f79bc7c.webp",
        "width": 3000,
        "height": 2001
      },
      "amenity_image_alt_text": "Luxurious Bathroom at Cloverset Active Adult Apartments, Kansas City",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_00081c65058d4b2045f66ae5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "yardi",
      "external_id": "87989762",
      "title": "Updated Homes Available*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a488cbd94ad192621bc96e36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "yardi",
      "external_id": "122011370",
      "title": "Upgraded Counters*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101d-cd25-72e8-b897-01dc9df4b149.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, granite countertops, stainless steel appliances, and a view into the living area.",
        "public_id": "01a0101d-cd25-72e8-b897-01dc9df4b149",
        "storage_key": "property/6767906449167593/01a0101d-cd25-72e8-b897-01dc9df4b149.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Modern Kitchen with cabinets and appliances at Cloverset Active Adult Apartments, Kansas City, MO, 64114",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_50b6d26bd6dd4b468c710ffa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "yardi",
      "external_id": "122011369",
      "title": "Upgraded Lighting*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_463d30078869e01d3a4ab679",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "yardi",
      "external_id": "122011347",
      "title": "Plank Flooring*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101d-ef87-7124-8110-0ddcbf386d60.webp",
      "amenity_image_media": {
        "alt_text": "Spacious living room with a sofa, fireplace, dining area, and large window.",
        "public_id": "01a0101d-ef87-7124-8110-0ddcbf386d60",
        "storage_key": "property/6767906449167593/01a0101d-ef87-7124-8110-0ddcbf386d60.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Spacious Living Room at Cloverset Active Adult Apartments, Kansas City, MO",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_fe91d0cece63695fb4990e22",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101d-9bc1-724e-a778-0c6043a098fc.webp",
      "image_media": {
        "alt_text": "Modern living and dining area with a white table and chairs, a sofa, and two accent chairs.",
        "public_id": "01a0101d-9bc1-724e-a778-0c6043a098fc",
        "storage_key": "property/6767906449167593/01a0101d-9bc1-724e-a778-0c6043a098fc.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Step into a beautifully designed living space, featuring an open-concept layout that seamlessly connects the dining area, living room, and kitchen.",
      "link": "false",
      "alt_text": "Modern living and dining area with a white table and chairs, a sofa, and two accent chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/16-DSC02982_final.jpg"
    },
    {
      "id": "ec_c2990fcfe6d71735ea320df0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101e-1119-777b-9f99-0a42d7f5ef1b.webp",
      "image_media": {
        "alt_text": "Spacious living room and kitchen area with modern furniture and appliances.",
        "public_id": "01a0101e-1119-777b-9f99-0a42d7f5ef1b",
        "storage_key": "property/6767906449167593/01a0101e-1119-777b-9f99-0a42d7f5ef1b.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this beautifully appointed apartment, featuring an open-concept living and dining area seamlessly flowing into a modern kitchen.",
      "link": "false",
      "alt_text": "Spacious living room and kitchen area with modern furniture and appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/14-DSC02977_final.jpg"
    },
    {
      "id": "ec_15ea1156e587446514a6c5b9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101e-0ec6-738a-b60e-9e0bbb3874e4.webp",
      "image_media": {
        "alt_text": "Living room and dining area with fireplace and sliding glass doors to balcony.",
        "public_id": "01a0101e-0ec6-738a-b60e-9e0bbb3874e4",
        "storage_key": "property/6767906449167593/01a0101e-0ec6-738a-b60e-9e0bbb3874e4.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Stylish living and dining space featuring a plush sofa, modern coffee table, and elegant dining set. Enjoy the view from your private balcony.",
      "link": "false",
      "alt_text": "Living room and dining area with fireplace and sliding glass doors to balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/08-DSC02928_final.jpg"
    },
    {
      "id": "ec_83a1ec5cbca48b3feb7742c0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101e-0e2d-7448-96f5-2a320bab227d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "01a0101e-0e2d-7448-96f5-2a320bab227d",
        "storage_key": "property/6767906449167593/01a0101e-0e2d-7448-96f5-2a320bab227d.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Step into this sleek and modern kitchen, featuring stainless steel appliances and elegant granite countertops. Perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/04-DSC02902_final.jpg"
    },
    {
      "id": "ec_016259550e0a862ce3825992",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101e-0e33-773e-9030-e157551e0093.webp",
      "image_media": {
        "alt_text": "Kitchen sink with white cabinets and countertop, and an espresso machine.",
        "public_id": "01a0101e-0e33-773e-9030-e157551e0093",
        "storage_key": "property/6767906449167593/01a0101e-0e33-773e-9030-e157551e0093.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring a stainless steel sink, white cabinets, granite countertops, and a professional espresso machine. Perfect for your morning coffee routine.",
      "link": "false",
      "alt_text": "Kitchen sink with white cabinets and countertop, and an espresso machine.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/02-DSC02837_final.jpg"
    },
    {
      "id": "ec_6184758cd0382f8dccefbb36",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101e-0e56-71ed-9f83-7d5abc38f192.webp",
      "image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, granite countertops, stainless steel appliances, and a view of the living room.",
        "public_id": "01a0101e-0e56-71ed-9f83-7d5abc38f192",
        "storage_key": "property/6767906449167593/01a0101e-0e56-71ed-9f83-7d5abc38f192.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring sleek light wood cabinetry, premium granite countertops, and stainless steel appliances. Enjoy seamless flow into the living area.",
      "link": "false",
      "alt_text": "Modern kitchen with light wood cabinets, granite countertops, stainless steel appliances, and a view of the living room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/06-DSC02917_final.jpg"
    },
    {
      "id": "ec_a54d907901e4a99306ad3c47",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101e-1bd4-7391-92f8-b5a2e806dc37.webp",
      "image_media": {
        "alt_text": "Bedroom with dresser, closet, ceiling fan and bed with geometric pattern blanket",
        "public_id": "01a0101e-1bd4-7391-92f8-b5a2e806dc37",
        "storage_key": "property/6767906449167593/01a0101e-1bd4-7391-92f8-b5a2e806dc37.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a modern dresser, a large closet with organized clothing, a ceiling fan, and a comfortable bed with a stylish geometric blanket.",
      "link": "false",
      "alt_text": "Bedroom with dresser, closet, ceiling fan and bed with geometric pattern blanket",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/24-DSC03032_final.jpg"
    },
    {
      "id": "ec_9cc66c46ed58cc507591b227",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101e-1d85-75da-915c-652e727253d2.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstands, ceiling fan, and window.",
        "public_id": "01a0101e-1d85-75da-915c-652e727253d2",
        "storage_key": "property/6767906449167593/01a0101e-1d85-75da-915c-652e727253d2.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a plush queen-size bed, modern nightstands with lamps, a convenient ceiling fan, and a bright window. This inviting space offers comfort and style for relaxation.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, nightstands, ceiling fan, and window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/28-DSC03042_final.jpg"
    },
    {
      "id": "ec_8dbb627dc9cd57db232db9e5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101e-1d8a-74c5-a1cd-d5cd519216ce.webp",
      "image_media": {
        "alt_text": "Spacious bedroom with a large bed, walk-in closet, and modern decor.",
        "public_id": "01a0101e-1d8a-74c5-a1cd-d5cd519216ce",
        "storage_key": "property/6767906449167593/01a0101e-1d8a-74c5-a1cd-d5cd519216ce.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed bedroom, featuring a plush bed and ample storage with a walk-in closet. Perfect for relaxation.",
      "link": "false",
      "alt_text": "Spacious bedroom with a large bed, walk-in closet, and modern decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/22-DSC03027_final.jpg"
    },
    {
      "id": "ec_c92656e3986b8e2e2ee02c6e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101e-1e11-774f-84e2-5a7684320041.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a king-sized bed, dresser, and ceiling fan.",
        "public_id": "01a0101e-1e11-774f-84e2-5a7684320041",
        "storage_key": "property/6767906449167593/01a0101e-1e11-774f-84e2-5a7684320041.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed bedroom, featuring a plush king-sized bed, elegant dresser, and a cooling ceiling fan. A perfect retreat.",
      "link": "false",
      "alt_text": "Cozy bedroom with a king-sized bed, dresser, and ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/26-DSC03037_final.jpg"
    },
    {
      "id": "ec_4e521741d9d09662e767eb4d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101e-1ff5-7464-8ad3-51c935bfd147.webp",
      "image_media": {
        "alt_text": "A clean and modern bathroom with a white bathtub, toilet, and vanity.",
        "public_id": "01a0101e-1ff5-7464-8ad3-51c935bfd147",
        "storage_key": "property/6767906449167593/01a0101e-1ff5-7464-8ad3-51c935bfd147.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "This apartment bathroom features a clean white bathtub and toilet, complemented by a light wood vanity with a marbled countertop and a large mirror.",
      "link": "false",
      "alt_text": "A clean and modern bathroom with a white bathtub, toilet, and vanity.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/30-DSC03052.jpg"
    },
    {
      "id": "ec_18ab380a9310018f0b06d4d1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101e-2918-73ea-b957-f11d3d603fd9.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, sink, toilet, and shower.",
        "public_id": "01a0101e-2918-73ea-b957-f11d3d603fd9",
        "storage_key": "property/6767906449167593/01a0101e-2918-73ea-b957-f11d3d603fd9.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Freshen up in the spacious bathroom, featuring a large vanity, a clean toilet, and a modern glass-enclosed shower.",
      "link": "false",
      "alt_text": "Modern bathroom with vanity, sink, toilet, and shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/31-DSC03062.jpg"
    },
    {
      "id": "ec_e50a6274a31e3694e1db1df5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101e-2c88-732f-835e-53c286efee31.webp",
      "image_media": {
        "alt_text": "View of the property's swimming pool and apartment buildings from a balcony.",
        "public_id": "01a0101e-2c88-732f-835e-53c286efee31",
        "storage_key": "property/6767906449167593/01a0101e-2c88-732f-835e-53c286efee31.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy the outdoors with a view of the refreshing swimming pool and lush greenery from your private balcony.",
      "link": "false",
      "alt_text": "View of the property's swimming pool and apartment buildings from a balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/32-DSC03117 Winter to Summer.jpg"
    },
    {
      "id": "ec_20a28090bafb01d6db190b39",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc928-69ac-7330-8433-1eadda3d838f.webp",
      "image_media": {
        "alt_text": "The Cloverset Apartment Homes monument sign with phone number and website.",
        "public_id": "019fc928-69ac-7330-8433-1eadda3d838f",
        "storage_key": "property/6767906449167593/019fc928-69ac-7330-8433-1eadda3d838f.webp",
        "width": 1382,
        "height": 921
      },
      "title": "Community",
      "description": "Welcome to The Cloverset Apartment Homes. Contact us at 816-942-8585 or visit CloversetApts.com.",
      "link": "false",
      "alt_text": "The Cloverset Apartment Homes monument sign with phone number and website.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/2CV-Amenities-27.jpg"
    },
    {
      "id": "ec_48b0f44324fdbb0b3a6ad45f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101e-2c8c-76a2-9936-444288864ed6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "01a0101e-2c8c-76a2-9936-444288864ed6",
        "storage_key": "property/6767906449167593/01a0101e-2c8c-76a2-9936-444288864ed6.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this sleek, modern kitchen featuring dark wood cabinetry, granite countertops, and a full suite of stainless steel appliances. Perfect for any home chef.",
      "link": "false",
      "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/08-DSC02102_final(1).jpg"
    },
    {
      "id": "ec_b518938dc4e11dd8d9863c87",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc928-69b7-74af-8af8-26b6db7e62ff.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, granite countertops, stove, and microwave.",
        "public_id": "019fc928-69b7-74af-8af8-26b6db7e62ff",
        "storage_key": "property/6767906449167593/019fc928-69b7-74af-8af8-26b6db7e62ff.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring dark wood cabinetry, granite countertops, a black electric stove, and a built-in microwave, perfect for meal preparation.",
      "link": "false",
      "alt_text": "Kitchen with dark wood cabinets, granite countertops, stove, and microwave.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/2CV-1x1A1new-5.jpg"
    },
    {
      "id": "ec_cc0dd96d0aeac6df9551319d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101e-2ed6-716d-aefe-c339f3f905d3.webp",
      "image_media": {
        "alt_text": "A bedroom with a queen-size bed, dresser, closet, and en-suite bathroom.",
        "public_id": "01a0101e-2ed6-716d-aefe-c339f3f905d3",
        "storage_key": "property/6767906449167593/01a0101e-2ed6-716d-aefe-c339f3f905d3.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, ample closet space, and a private en-suite bathroom for your convenience.",
      "link": "false",
      "alt_text": "A bedroom with a queen-size bed, dresser, closet, and en-suite bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12-DSC02147_final(1).jpg"
    },
    {
      "id": "ec_7ffc4eaffa3d8a816d476502",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101e-32b4-7351-a951-11642406c418.webp",
      "image_media": {
        "alt_text": "Dining area with table and chairs, open to kitchen with bar stools.",
        "public_id": "01a0101e-32b4-7351-a951-11642406c418",
        "storage_key": "property/6767906449167593/01a0101e-32b4-7351-a951-11642406c418.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Stylish dining area with a glass-top table and comfortable chairs, adjacent to a modern kitchen with a breakfast bar, perfect for entertaining.",
      "link": "false",
      "alt_text": "Dining area with table and chairs, open to kitchen with bar stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01-DSC02022_final.jpg"
    },
    {
      "id": "ec_988a597e1b1d821298897cd7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc928-724f-732a-848f-6d94f8be5180.webp",
      "image_media": {
        "alt_text": "Exterior view of the apartment building entrance with landscaping",
        "public_id": "019fc928-724f-732a-848f-6d94f8be5180",
        "storage_key": "property/6767906449167593/019fc928-724f-732a-848f-6d94f8be5180.webp",
        "width": 1460,
        "height": 973
      },
      "title": "Community",
      "description": "Welcome to our community! This image shows the exterior of our building, highlighting the beautiful landscaping and entrance.",
      "link": "false",
      "alt_text": "Exterior view of the apartment building entrance with landscaping",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/2CV-Amenities-24.jpg"
    },
    {
      "id": "ec_9053ea660d234db99025a6b9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101e-3e71-763c-b370-3f2967065948.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex with outdoor swimming pool, tennis court, and surrounding buildings.",
        "public_id": "01a0101e-3e71-763c-b370-3f2967065948",
        "storage_key": "property/6767906449167593/01a0101e-3e71-763c-b370-3f2967065948.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy resort-style living with a sparkling outdoor swimming pool and a tennis court at our beautiful apartment community. Experience the perfect blend of relaxation and recreation.",
      "link": "false",
      "alt_text": "Aerial view of apartment complex with outdoor swimming pool, tennis court, and surrounding buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/11-10601 Jefferson St-11.jpg"
    },
    {
      "id": "ec_11a723393de9bdaa9f0453d9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101e-3c84-74fe-8396-d2d307c362fb.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "01a0101e-3c84-74fe-8396-d2d307c362fb",
        "storage_key": "property/6767906449167593/01a0101e-3c84-74fe-8396-d2d307c362fb.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Relax by our beautiful outdoor swimming pool, complete with comfortable lounge chairs and a shaded seating area.",
      "link": "false",
      "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/10-10601 Jefferson St-10.jpg"
    },
    {
      "id": "ec_31b836a63212e013c7fddbfe",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101e-3cec-745a-adca-2830952d8869.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs, dining tables, and umbrellas.",
        "public_id": "01a0101e-3cec-745a-adca-2830952d8869",
        "storage_key": "property/6767906449167593/01a0101e-3cec-745a-adca-2830952d8869.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy our beautiful outdoor swimming pool area, complete with comfortable lounge chairs and shaded dining tables for relaxation and gathering.",
      "link": "false",
      "alt_text": "Outdoor swimming pool area with lounge chairs, dining tables, and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/09-10601 Jefferson St-9.jpg"
    },
    {
      "id": "ec_88d9397a84660af14e44b426",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101d-ac49-7036-b3b8-25a061050e84.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "01a0101d-ac49-7036-b3b8-25a061050e84",
        "storage_key": "property/6767906449167593/01a0101d-ac49-7036-b3b8-25a061050e84.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and surrounded by the beautiful apartment community.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/07-10601 Jefferson St-7.jpg"
    },
    {
      "id": "ec_a0986560fc940b3919ff82f3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101e-3fd1-7627-998e-cd2578e505ac.webp",
      "image_media": {
        "alt_text": "Tennis court with apartment buildings in the background",
        "public_id": "01a0101e-3fd1-7627-998e-cd2578e505ac",
        "storage_key": "property/6767906449167593/01a0101e-3fd1-7627-998e-cd2578e505ac.webp",
        "width": 1800,
        "height": 1200
      },
      "title": "Community",
      "description": "Enjoy a friendly match on our tennis court, surrounded by lush greenery and apartment residences.",
      "link": "false",
      "alt_text": "Tennis court with apartment buildings in the background",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/a994b39f-8b85-4d71-b311-3a388a0c617c.jpg"
    },
    {
      "id": "ec_ce5f3e307f1f6f40b6ad0d8d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101e-4189-7685-ac74-9f6a08772d9d.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, recumbent bikes, and weight bench.",
        "public_id": "01a0101e-4189-7685-ac74-9f6a08772d9d",
        "storage_key": "property/6767906449167593/01a0101e-4189-7685-ac74-9f6a08772d9d.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines and strength training equipment for a complete workout.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, ellipticals, recumbent bikes, and weight bench.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/04-10601 Jefferson St-4.jpg"
    },
    {
      "id": "ec_3ddec3505a62a3842aa3c713",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101d-aa36-7139-ba70-cbd66de058c7.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, recumbent bikes, and weights.",
        "public_id": "01a0101d-aa36-7139-ba70-cbd66de058c7",
        "storage_key": "property/6767906449167593/01a0101d-aa36-7139-ba70-cbd66de058c7.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, equipped with a variety of cardio machines and free weights.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, ellipticals, recumbent bikes, and weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/05-10601 Jefferson St-5.jpg"
    },
    {
      "id": "ec_2235f8bcf3cb3204e6c26b63",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101e-4bef-70eb-951c-70bb5f1ba8ed.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables under a wooden pergola.",
        "public_id": "01a0101e-4bef-70eb-951c-70bb5f1ba8ed",
        "storage_key": "property/6767906449167593/01a0101e-4bef-70eb-951c-70bb5f1ba8ed.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool, featuring comfortable lounge chairs and shaded seating areas perfect for enjoying the sunshine.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and tables under a wooden pergola.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/08-10601 Jefferson St-8.jpg"
    },
    {
      "id": "ec_56315deb47ada875e6973ca0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101e-4c4e-74a0-8ea1-e89095c19920.webp",
      "image_media": {
        "alt_text": "Interior of a community lounge with seating areas, a TV, and a large open doorway revealing an exterior view.",
        "public_id": "01a0101e-4c4e-74a0-8ea1-e89095c19920",
        "storage_key": "property/6767906449167593/01a0101e-4c4e-74a0-8ea1-e89095c19920.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, featuring comfortable seating, a large screen TV, and access to outdoor spaces.",
      "link": "false",
      "alt_text": "Interior of a community lounge with seating areas, a TV, and a large open doorway revealing an exterior view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01-10601 Jefferson St-1.jpg"
    },
    {
      "id": "ec_0c12723c73a25ebe811be0df",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101d-ab25-76de-9e06-dca7eeabe940.webp",
      "image_media": {
        "alt_text": "Community lounge area with tables and chairs.",
        "public_id": "01a0101d-ab25-76de-9e06-dca7eeabe940",
        "storage_key": "property/6767906449167593/01a0101d-ab25-76de-9e06-dca7eeabe940.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Relax and socialize in our inviting community lounge, featuring comfortable seating and game tables for resident enjoyment.",
      "link": "false",
      "alt_text": "Community lounge area with tables and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/02-10601 Jefferson St-2.jpg"
    },
    {
      "id": "ec_dfff180d375d89f720bdd0d7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101e-4fa8-766c-8ce5-b9aee85f5ea7.webp",
      "image_media": {
        "alt_text": "Coffee station with Keurig machine, cups, and syrups.",
        "public_id": "01a0101e-4fa8-766c-8ce5-b9aee85f5ea7",
        "storage_key": "property/6767906449167593/01a0101e-4fa8-766c-8ce5-b9aee85f5ea7.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee, tea, and hot chocolate at our resident coffee bar.",
      "link": "false",
      "alt_text": "Coffee station with Keurig machine, cups, and syrups.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/03-10601 Jefferson St-3.jpg"
    },
    {
      "id": "ec_a1078d296d36c4a1716f2f65",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101d-aac0-76ba-be6b-95d764137713.webp",
      "image_media": {
        "alt_text": "Two commercial washing machines and dryers in a laundry room",
        "public_id": "01a0101d-aac0-76ba-be6b-95d764137713",
        "storage_key": "property/6767906449167593/01a0101d-aac0-76ba-be6b-95d764137713.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities with modern washing machines and dryers available for resident use.",
      "link": "false",
      "alt_text": "Two commercial washing machines and dryers in a laundry room",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/06-10601 Jefferson St-6.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_31efe14c-487b-4c34-aa5f-c7cd91afb758",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Jasper's Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1201 103rd St, Kansas City, MO 64114, USA",
      "poi_short_description": "Venerable upscale restaurant serving Italian cuisine in a special-occasion setting.",
      "poi_long_description": "Venerable upscale restaurant serving Italian cuisine in a special-occasion setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92a-f284-75c3-92d5-9edc82ce4ea0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc92a-f284-75c3-92d5-9edc82ce4ea0",
        "storage_key": "property/6767906449167593/019fc92a-f284-75c3-92d5-9edc82ce4ea0.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "http://www.jasperskc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15828340062765138346&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jaspers-italian-restaurant",
      "poi_latitude": "38.94142",
      "poi_longitude": "-94.6058056",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-941-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0bc-705a-a037-d4a1e3871c1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0bc-705a-a037-d4a1e3871c1f",
        "storage_key": "property/6767906449167593/019fc927-d0bc-705a-a037-d4a1e3871c1f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbxzZqgHpwIcRqkEzyWyPqds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_599b6aa2-59df-4c4f-9dc2-27be02aa40b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Charlie D's Seafood and Chicken",
      "poi_type": "Restaurants",
      "poi_address": "600 E 99th St, Kansas City, MO 64131, USA",
      "poi_short_description": "Relaxed, strip-mall diner dishing up American home-style classics like fried chicken & catfish.",
      "poi_long_description": "Relaxed, strip-mall diner dishing up American home-style classics like fried chicken & catfish.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101a-9cdc-741e-a388-23ff2bcffd2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-9cdc-741e-a388-23ff2bcffd2b",
        "storage_key": "property/6767906449167593/01a0101a-9cdc-741e-a388-23ff2bcffd2b.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://charliedsonline.com/99th-street?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=11815734818826639101&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlie-ds-seafood-and-chicken",
      "poi_latitude": "38.9488106",
      "poi_longitude": "-94.5832443",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-942-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0bc-705a-a037-d4a1e3871c1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0bc-705a-a037-d4a1e3871c1f",
        "storage_key": "property/6767906449167593/019fc927-d0bc-705a-a037-d4a1e3871c1f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfxtdz_LowIcR_VZgHDfs-aM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_372525a0-0bf3-4e3a-abe1-de8c5f8c97ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Thai House Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "9938 Holmes Rd, Kansas City, MO 64131, USA",
      "poi_short_description": "Thai restaurant with slick decor serving noodles, seafood & an extensive vegetarian menu.",
      "poi_long_description": "Thai restaurant with slick decor serving noodles, seafood & an extensive vegetarian menu.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101a-b006-7616-8ffb-4e927b902ef1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-b006-7616-8ffb-4e927b902ef1",
        "storage_key": "property/6767906449167593/01a0101a-b006-7616-8ffb-4e927b902ef1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thaihousekcmo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5705318528124816071&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thai-house-restaurant",
      "poi_latitude": "38.94664",
      "poi_longitude": "-94.5830238",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-943-1388",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0bc-705a-a037-d4a1e3871c1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0bc-705a-a037-d4a1e3871c1f",
        "storage_key": "property/6767906449167593/019fc927-d0bc-705a-a037-d4a1e3871c1f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB2z2J43owIcRx4pVJ_lcLU8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_b3e30933-dcce-480f-85f2-94cad5183cb3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Never on Sunday Greek Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "9932 Holmes Rd, Kansas City, MO 64131, USA",
      "poi_short_description": "Pared-down counter serve offering simple Greek bites such as hummus, gyros & souvlaki.",
      "poi_long_description": "Pared-down counter serve offering simple Greek bites such as hummus, gyros & souvlaki.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101a-982c-779b-8645-fbb13c6ff04e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-982c-779b-8645-fbb13c6ff04e",
        "storage_key": "property/6767906449167593/01a0101a-982c-779b-8645-fbb13c6ff04e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.nosgreek.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16370549952069144351&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "never-on-sunday-greek-restaurant",
      "poi_latitude": "38.9466397",
      "poi_longitude": "-94.583323",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-942-0029",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0bc-705a-a037-d4a1e3871c1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0bc-705a-a037-d4a1e3871c1f",
        "storage_key": "property/6767906449167593/019fc927-d0bc-705a-a037-d4a1e3871c1f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJeXzpJ43owIcRH4_eTnLgL-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "greek_restaurant"
    },
    {
      "id": "custom_c41d949c-f98e-47ca-93a2-5ad7d4de118a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "El Nopalito",
      "poi_type": "Restaurants",
      "poi_address": "9928 Holmes Rd, Kansas City, MO 64131, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101a-9882-7735-b303-9423ef62fba2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-9882-7735-b303-9423ef62fba2",
        "storage_key": "property/6767906449167593/01a0101a-9882-7735-b303-9423ef62fba2.webp",
        "width": 1141,
        "height": 1280
      },
      "poi_business_url": "https://www.elnopalitokansascity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2068157933473572966&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-nopalito",
      "poi_latitude": "38.9465807",
      "poi_longitude": "-94.5834216",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-442-7044",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0bc-705a-a037-d4a1e3871c1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0bc-705a-a037-d4a1e3871c1f",
        "storage_key": "property/6767906449167593/019fc927-d0bc-705a-a037-d4a1e3871c1f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAVYreVTpwIcRZigZ1K6Ssxw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_40085634-2be6-48f5-a2f0-bebd04643948",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Big Belly's Kitchen & Catering",
      "poi_type": "Restaurants",
      "poi_address": "8940 Wornall Rd, Kansas City, MO 64114, USA",
      "poi_short_description": "Casual Italian restaurant offering comfort food and quick bites, plus wine and beer.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101a-974f-7307-a68c-82f3a93a9ded.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-974f-7307-a68c-82f3a93a9ded",
        "storage_key": "property/6767906449167593/01a0101a-974f-7307-a68c-82f3a93a9ded.webp",
        "width": 768,
        "height": 1024
      },
      "poi_business_url": "http://www.bigbellykc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4820396872846737319&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-bellys-kitchen--catering",
      "poi_latitude": "38.9658149",
      "poi_longitude": "-94.5959288",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-216-6498",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0bc-705a-a037-d4a1e3871c1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0bc-705a-a037-d4a1e3871c1f",
        "storage_key": "property/6767906449167593/019fc927-d0bc-705a-a037-d4a1e3871c1f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1VgatPDpwIcRp_9ukmp95UI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_f3915aaa-1188-46a4-aafb-05c1ef293b8a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Pizza Hut",
      "poi_type": "Restaurants",
      "poi_address": "10147 Wornall Rd, Kansas City, MO 64114, USA",
      "poi_short_description": "Popular delivery, carry-out & dine-in chain known for pizza, wings & pasta, plus sides & desserts.",
      "poi_long_description": "Popular delivery, carry-out & dine-in chain known for pizza, wings & pasta, plus sides & desserts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101a-9c0e-7102-8365-6a911e266eb2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-9c0e-7102-8365-6a911e266eb2",
        "storage_key": "property/6767906449167593/01a0101a-9c0e-7102-8365-6a911e266eb2.webp",
        "width": 1280,
        "height": 921
      },
      "poi_business_url": "https://locations.pizzahut.com/mo/kansas-city/10147-wornall-road?utm_medium=organic&utm_source=local&utm_campaign=googlelistings&utm_content=website&utm_term=302600",
      "poi_directions_map_url": "https://maps.google.com/?cid=1037007924910067295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pizza-hut",
      "poi_latitude": "38.9435568",
      "poi_longitude": "-94.59597250000002",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-942-3688",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0ab-7293-beda-8a585de8eebc",
        "storage_key": "property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT3Lf0_vowIcRX46HoTYxZA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_delivery"
    },
    {
      "id": "custom_f964806f-c35f-4597-ab89-65a1cb05dc6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Chick Bo-Bao",
      "poi_type": "Restaurants",
      "poi_address": "10143 Wornall Rd, Kansas City, MO 64114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101a-9734-7379-8be3-5e1b34558277.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-9734-7379-8be3-5e1b34558277",
        "storage_key": "property/6767906449167593/01a0101a-9734-7379-8be3-5e1b34558277.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chickbobaokcmo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6106310093858155741&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chick-bo-bao",
      "poi_latitude": "38.9436878",
      "poi_longitude": "-94.5959604",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-794-0026",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0bc-705a-a037-d4a1e3871c1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0bc-705a-a037-d4a1e3871c1f",
        "storage_key": "property/6767906449167593/019fc927-d0bc-705a-a037-d4a1e3871c1f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJe3rLoVzpwIcR3SzMgK34vVQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_c6cabc3a-b401-4ae3-a94f-16264f858a49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Jovito's Italian Café & Deli",
      "poi_type": "Restaurants",
      "poi_address": "7408 Wornall Rd, Kansas City, MO 64114, USA",
      "poi_short_description": "Small eatery dispensing Italian sandwiches, calzones & other deli fare in an unpretentious setting.",
      "poi_long_description": "Small eatery dispensing Italian sandwiches, calzones & other deli fare in an unpretentious setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92a-fe50-72b9-8f35-56a50d599d38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc92a-fe50-72b9-8f35-56a50d599d38",
        "storage_key": "property/6767906449167593/019fc92a-fe50-72b9-8f35-56a50d599d38.webp",
        "width": 1280,
        "height": 1250
      },
      "poi_business_url": "https://www.jovitostogo.com/order",
      "poi_directions_map_url": "https://maps.google.com/?cid=4202410889431177515&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jovitos-italian-caf--deli",
      "poi_latitude": "38.993651",
      "poi_longitude": "-94.5944696",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-943-9988",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0bc-705a-a037-d4a1e3871c1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0bc-705a-a037-d4a1e3871c1f",
        "storage_key": "property/6767906449167593/019fc927-d0bc-705a-a037-d4a1e3871c1f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPYnmpNPpwIcRK1nHSHD2UTo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_3194e489-84bf-481c-85c4-dbc84941ffbd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Noodles and Company",
      "poi_type": "Restaurants",
      "poi_address": "7600 State Line Rd, Prairie Village, KS 66208, USA",
      "poi_short_description": "Counter-serve chain offering international noodle & pasta dishes from mac 'n' cheese to Pad Thai.",
      "poi_long_description": "Counter-serve chain offering international noodle & pasta dishes from mac 'n' cheese to Pad Thai.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101a-981b-7150-a029-4834f3ae5314.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-981b-7150-a029-4834f3ae5314",
        "storage_key": "property/6767906449167593/01a0101a-981b-7150-a029-4834f3ae5314.webp",
        "width": 1280,
        "height": 803
      },
      "poi_business_url": "https://locations.noodles.com/ks/prairie-village/7600-state-line-rd?utm_campaign=soci&utm_medium=organic&utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=2909359222506698931&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "noodles-and-company",
      "poi_latitude": "38.9902623",
      "poi_longitude": "-94.6086451",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-381-4280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0bc-705a-a037-d4a1e3871c1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0bc-705a-a037-d4a1e3871c1f",
        "storage_key": "property/6767906449167593/019fc927-d0bc-705a-a037-d4a1e3871c1f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJn1RxWNfuwIcRs7iEZcweYCg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_612d1f66-69e2-4be5-8492-1c9f88593d29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "QuikTrip",
      "poi_type": "Transportation & Transit",
      "poi_address": "10601 State Line Rd, Kansas City, MO 64114, USA",
      "poi_short_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_long_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92a-ff72-714a-b760-d1d7d0b1082a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc92a-ff72-714a-b760-d1d7d0b1082a",
        "storage_key": "property/6767906449167593/019fc92a-ff72-714a-b760-d1d7d0b1082a.webp",
        "width": 600,
        "height": 339
      },
      "poi_business_url": "https://locations.quiktrip.com/mo/kansas-city/10601-state-line-rd?utm_source=gmb&utm_medium=yext&y_source=1_MTYwMDM4NTItNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10842339784816987583&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quiktrip",
      "poi_latitude": "38.9344638",
      "poi_longitude": "-94.6068235",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-942-3355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-48d9-72ba-93c5-5e5b9f86b82f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc92b-48d9-72ba-93c5-5e5b9f86b82f",
        "storage_key": "property/6767906449167593/019fc92b-48d9-72ba-93c5-5e5b9f86b82f.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJv3D7v6vpwIcRvw0a0Ja6d5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_c88f35fe-af82-4ea4-808f-71e7db2ddd30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Cosentino's Price Chopper",
      "poi_type": "Shopping & Retail",
      "poi_address": "1030 103rd St, Kansas City, MO 64114, USA",
      "poi_short_description": "Supermarket featuring organic produce, meat, deli counter, prepared foods, bakery and friendly staff with an on-site pharmacy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-00f9-737d-bd03-417c8ac15b30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc92b-00f9-737d-bd03-417c8ac15b30",
        "storage_key": "property/6767906449167593/019fc92b-00f9-737d-bd03-417c8ac15b30.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mypricechopper.com/store-details?storeId=73",
      "poi_directions_map_url": "https://maps.google.com/?cid=1547671457070995276&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cosentinos-price-chopper",
      "poi_latitude": "38.9438154",
      "poi_longitude": "-94.6054177",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-942-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0ff-7039-be9a-bd1c5dcd5bbd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0ff-7039-be9a-bd1c5dcd5bbd",
        "storage_key": "property/6767906449167593/019fc927-d0ff-7039-be9a-bd1c5dcd5bbd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2Zs71gHpwIcRTFe6g_1uehU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_42d7087f-3006-4ea1-aa74-f97b678d58c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Cigarettes 4 Less, Inc.",
      "poi_type": "Shopping & Retail",
      "poi_address": "1255 103rd St, Kansas City, MO 64114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101a-9bbb-73fb-8f5d-03c3d657f9c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-9bbb-73fb-8f5d-03c3d657f9c7",
        "storage_key": "property/6767906449167593/01a0101a-9bbb-73fb-8f5d-03c3d657f9c7.webp",
        "width": 1280,
        "height": 1072
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9617907154304519719&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cigarettes-4-less-inc",
      "poi_latitude": "38.9412245",
      "poi_longitude": "-94.6072668",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-942-0801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-48db-713d-9e43-84163ef0d280.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc92b-48db-713d-9e43-84163ef0d280",
        "storage_key": "property/6767906449167593/019fc92b-48db-713d-9e43-84163ef0d280.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZfvbBwHpwIcRJ04CV5mreYU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_227e3a0d-8b3b-4fa5-9d5e-ca97fdbfd3ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "8509 State Line Rd, Kansas City, MO 64114, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019ff6c3-89c5-7390-b914-7556b2aa77c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c3-89c5-7390-b914-7556b2aa77c9",
        "storage_key": "property/6767906449167593/019ff6c3-89c5-7390-b914-7556b2aa77c9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cvs.com/store-locator/kansas-city-mo-pharmacies/8509-state-line-rd-kansas-city-mo-64114/storeid=16770?WT.mc_id=LS_GOOGLE_RX_16770",
      "poi_directions_map_url": "https://maps.google.com/?cid=13999286614230798215&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "38.9717354",
      "poi_longitude": "-94.6074334",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-444-0019",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-48f2-7511-b5ac-3ba26f487fe3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc92b-48f2-7511-b5ac-3ba26f487fe3",
        "storage_key": "property/6767906449167593/019fc92b-48f2-7511-b5ac-3ba26f487fe3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh4wORSnpwIcRh48bFgF1R8I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_cf1a85cc-b3fe-4694-b130-c0c6d0067785",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "7511 Wornall Rd, Kansas City, MO 64114, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019ff6c3-8af7-77db-a2ac-ee312e5e09ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c3-8af7-77db-a2ac-ee312e5e09ac",
        "storage_key": "property/6767906449167593/019ff6c3-8af7-77db-a2ac-ee312e5e09ac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/mo/kansas-city/7511-wornall-road/f300",
      "poi_directions_map_url": "https://maps.google.com/?cid=894879846790879640&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "38.991599",
      "poi_longitude": "-94.592771",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0ff-7039-be9a-bd1c5dcd5bbd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0ff-7039-be9a-bd1c5dcd5bbd",
        "storage_key": "property/6767906449167593/019fc927-d0ff-7039-be9a-bd1c5dcd5bbd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRZfjWCXvwIcRmFmguHpAaww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_d295f7f5-6a31-4a47-9711-2a9328d5335e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Ward Parkway Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "8600 Ward Pkwy, Kansas City, MO 64114, USA",
      "poi_short_description": "Popular shopping center featuring familiar big-name stores (like Target and HomeGoods), eateries and gym options, as well as a movie theater.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101a-a34b-7428-8de7-37d983c14255.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-a34b-7428-8de7-37d983c14255",
        "storage_key": "property/6767906449167593/01a0101a-a34b-7428-8de7-37d983c14255.webp",
        "width": 1280,
        "height": 1144
      },
      "poi_business_url": "http://www.wardparkwaycenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12737272864935780034&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ward-parkway-center",
      "poi_latitude": "38.9702054",
      "poi_longitude": "-94.606055",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-363-3545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-48db-713d-9e43-84163ef0d280.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc92b-48db-713d-9e43-84163ef0d280",
        "storage_key": "property/6767906449167593/019fc92b-48db-713d-9e43-84163ef0d280.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJp3psGfLpwIcRwh64iS_iw7A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_f30c271c-3434-45bf-b654-48ef2f799a6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Watts Mill Plaza",
      "poi_type": "Shopping & Retail",
      "poi_address": "1020-1236 103rd St, Kansas City, MO 64114, USA",
      "poi_short_description": "Familiar grocery chain offering produce, meat and seafood, as well as a bakery and deli.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101a-9f7e-778b-a3c7-98e265412782.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-9f7e-778b-a3c7-98e265412782",
        "storage_key": "property/6767906449167593/01a0101a-9f7e-778b-a3c7-98e265412782.webp",
        "width": 1000,
        "height": 563
      },
      "poi_business_url": "https://brixmor.com/leasing/retail-space/mo/kansas-city/watts-mill-plaza?utm_source=gmb&utm_medium=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=16497578285627734253&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "watts-mill-plaza",
      "poi_latitude": "38.9430023",
      "poi_longitude": "-94.6055527",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 610-215-7939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-48db-713d-9e43-84163ef0d280.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc92b-48db-713d-9e43-84163ef0d280",
        "storage_key": "property/6767906449167593/019fc92b-48db-713d-9e43-84163ef0d280.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJTaskAgHpwIcR7fgJ-Qos8-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_797090af-82ba-4a28-9f37-713d661f37a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "8509 State Line Rd, Kansas City, MO 64114, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-0677-75cb-bb15-5178cd11b1d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc92b-0677-75cb-bb15-5178cd11b1d1",
        "storage_key": "property/6767906449167593/019fc92b-0677-75cb-bb15-5178cd11b1d1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/ward-parkway/1436",
      "poi_directions_map_url": "https://maps.google.com/?cid=10429168010455215149&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "38.9717354",
      "poi_longitude": "-94.6074334",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-444-6012",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-48db-713d-9e43-84163ef0d280.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc92b-48db-713d-9e43-84163ef0d280",
        "storage_key": "property/6767906449167593/019fc92b-48db-713d-9e43-84163ef0d280.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJh4wORSnpwIcRLewMpgzZu5A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_85083948-0022-4f5b-990f-77fc440f8ec0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "7500 Wornall Rd, Kansas City, MO 64114, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-0294-71fb-a71a-67744db62e88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc92b-0294-71fb-a71a-67744db62e88",
        "storage_key": "property/6767906449167593/019fc92b-0294-71fb-a71a-67744db62e88.webp",
        "width": 1280,
        "height": 639
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-7500+wornall+rd-kansas+city-mo-64114/id=4235",
      "poi_directions_map_url": "https://maps.google.com/?cid=1346018030872091617&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "38.9919704",
      "poi_longitude": "-94.5948815",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-444-4179",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0ab-7293-beda-8a585de8eebc",
        "storage_key": "property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-xpbXSXvwIcR4dtmf0QErhI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_fde38076-9a27-4b18-9d7f-a9a61326c4a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Punkin Patch Child Development Center",
      "poi_type": "Education",
      "poi_address": "100 Red Bridge Rd, Kansas City, MO 64114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101a-a0c7-75dd-b763-8c598d625f81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-a0c7-75dd-b763-8c598d625f81",
        "storage_key": "property/6767906449167593/01a0101a-a0c7-75dd-b763-8c598d625f81.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "http://www.punkinpatchcdc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8049812737825575858&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "punkin-patch-child-development-center",
      "poi_latitude": "38.9270917",
      "poi_longitude": "-94.5944606",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-942-1927",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0a9-72fa-a225-ebe5ae6b439e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0a9-72fa-a225-ebe5ae6b439e",
        "storage_key": "property/6767906449167593/019fc927-d0a9-72fa-a225-ebe5ae6b439e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAwbejU_owIcRshOCCgmutm8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_6b7ba263-cf0c-445b-9573-d06c3f8b93a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Red Bridge Elementary School",
      "poi_type": "Education",
      "poi_address": "10781 Oak St, Kansas City, MO 64114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.center.k12.mo.us/o/rbelem",
      "poi_directions_map_url": "https://maps.google.com/?cid=7716474445093030848&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-bridge-elementary-school",
      "poi_latitude": "38.9324283",
      "poi_longitude": "-94.5868675",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-612-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0a9-72fa-a225-ebe5ae6b439e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0a9-72fa-a225-ebe5ae6b439e",
        "storage_key": "property/6767906449167593/019fc927-d0a9-72fa-a225-ebe5ae6b439e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXUxFe1zowIcRwEsmyp9sFms",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_584b45a9-04e1-4d5c-8be3-c6f458f91d20",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Indian Creek Elementary School",
      "poi_type": "Education",
      "poi_address": "9801 Grand Ave, Kansas City, MO 64114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-0a12-7019-8261-e7f038dd1521.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc92b-0a12-7019-8261-e7f038dd1521",
        "storage_key": "property/6767906449167593/019fc92b-0a12-7019-8261-e7f038dd1521.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.center.k12.mo.us/o/icelem",
      "poi_directions_map_url": "https://maps.google.com/?cid=15177451750171918317&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "indian-creek-elementary-school",
      "poi_latitude": "38.9503809",
      "poi_longitude": "-94.5882326",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-612-4250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0a9-72fa-a225-ebe5ae6b439e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0a9-72fa-a225-ebe5ae6b439e",
        "storage_key": "property/6767906449167593/019fc927-d0a9-72fa-a225-ebe5ae6b439e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJiUwL_e3owIcR7b-gBPQjodI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_d9e4c18f-3b23-4516-ab6d-466ce374c139",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Center Middle School",
      "poi_type": "Education",
      "poi_address": "326 103rd St, Kansas City, MO 64114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.center.k12.mo.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14536298216512667038&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "center-middle-school",
      "poi_latitude": "38.9421719",
      "poi_longitude": "-94.5903004",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-612-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0a9-72fa-a225-ebe5ae6b439e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0a9-72fa-a225-ebe5ae6b439e",
        "storage_key": "property/6767906449167593/019fc927-d0a9-72fa-a225-ebe5ae6b439e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJT0K4k_bowIcRnr1hGDZOu8k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_27992392-51a6-48d1-8313-9ac0fb2731b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Boone Elementary School",
      "poi_type": "Education",
      "poi_address": "8817 Wornall Rd, Kansas City, MO 64114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-1057-744f-932d-c677e2a7d0b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc92b-1057-744f-932d-c677e2a7d0b4",
        "storage_key": "property/6767906449167593/019fc92b-1057-744f-932d-c677e2a7d0b4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.center.k12.mo.us/o/belem",
      "poi_directions_map_url": "https://maps.google.com/?cid=8331786105145861248&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boone-elementary-school",
      "poi_latitude": "38.9675414",
      "poi_longitude": "-94.5940877",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-349-3613",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0a9-72fa-a225-ebe5ae6b439e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0a9-72fa-a225-ebe5ae6b439e",
        "storage_key": "property/6767906449167593/019fc927-d0a9-72fa-a225-ebe5ae6b439e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqxQtIdvowIcRgCTBpVFzoHM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_136760c2-0c48-4589-8db8-53c41ec0e639",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Yellowjacket Early Learning Center",
      "poi_type": "Education",
      "poi_address": "8817 Wornall Rd, Kansas City, MO 64114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.center.k12.mo.us/o/yelc",
      "poi_directions_map_url": "https://maps.google.com/?cid=16238716452305057303&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yellowjacket-early-learning-center",
      "poi_latitude": "38.9678858",
      "poi_longitude": "-94.5947632",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-349-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0a9-72fa-a225-ebe5ae6b439e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0a9-72fa-a225-ebe5ae6b439e",
        "storage_key": "property/6767906449167593/019fc927-d0a9-72fa-a225-ebe5ae6b439e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqxQtIdvowIcRFzbvs5OCW-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_ad20f383-5d3c-4bba-b603-e9f737e20cc7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Colonial Preschool",
      "poi_type": "Education",
      "poi_address": "9500 Wornall Rd, Kansas City, MO 64114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101a-bafe-76dc-98cb-ac4ceaa5789f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-bafe-76dc-98cb-ac4ceaa5789f",
        "storage_key": "property/6767906449167593/01a0101a-bafe-76dc-98cb-ac4ceaa5789f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://colonialkc.org/preschool-skc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10901660212879132198&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colonial-preschool",
      "poi_latitude": "38.9555291",
      "poi_longitude": "-94.5967193",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-501-3052",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0a9-72fa-a225-ebe5ae6b439e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0a9-72fa-a225-ebe5ae6b439e",
        "storage_key": "property/6767906449167593/019fc927-d0a9-72fa-a225-ebe5ae6b439e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFzpVvObowIcRJoarQjR6Spc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_d9d65c42-ad0f-4288-a762-9fe1b07709cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Ward Parkway Preschool",
      "poi_type": "Education",
      "poi_address": "7406 Ward Pkwy, Kansas City, MO 64114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101a-a69e-750b-99d5-82cba28b8d07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-a69e-750b-99d5-82cba28b8d07",
        "storage_key": "property/6767906449167593/01a0101a-a69e-750b-99d5-82cba28b8d07.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.wardparkwaypreschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13691517592407568210&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ward-parkway-preschool",
      "poi_latitude": "38.99372899999999",
      "poi_longitude": "-94.604215",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-361-2201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0a9-72fa-a225-ebe5ae6b439e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0a9-72fa-a225-ebe5ae6b439e",
        "storage_key": "property/6767906449167593/019fc927-d0a9-72fa-a225-ebe5ae6b439e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMQVfhtjuwIcRUu92o7UKAr4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_b0e3f640-6be2-4c71-9a14-63da1b05e294",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Notre Dame de Sion High School",
      "poi_type": "Education",
      "poi_address": "10631 Wornall Rd, Kansas City, MO 64114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-10ba-7737-a051-cd7a2a1593fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc92b-10ba-7737-a051-cd7a2a1593fa",
        "storage_key": "property/6767906449167593/019fc92b-10ba-7737-a051-cd7a2a1593fa.webp",
        "width": 1280,
        "height": 697
      },
      "poi_business_url": "http://www.ndsion.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14496372749344980158&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "notre-dame-de-sion-high-school",
      "poi_latitude": "38.9352177",
      "poi_longitude": "-94.5957129",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 816-942-3282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0a9-72fa-a225-ebe5ae6b439e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0a9-72fa-a225-ebe5ae6b439e",
        "storage_key": "property/6767906449167593/019fc927-d0a9-72fa-a225-ebe5ae6b439e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMxqT6VbowIcRvjxc4DV2Lck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_914277b6-f961-4b62-bd0b-4b9709121d35",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "The Barstow School",
      "poi_type": "Education",
      "poi_address": "11511 State Line Rd, Kansas City, MO 64114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101a-afc3-7163-91be-f162cfd3c2c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-afc3-7163-91be-f162cfd3c2c0",
        "storage_key": "property/6767906449167593/01a0101a-afc3-7163-91be-f162cfd3c2c0.webp",
        "width": 1280,
        "height": 947
      },
      "poi_business_url": "http://www.barstowschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15029272766334897611&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-barstow-school",
      "poi_latitude": "38.918111",
      "poi_longitude": "-94.6051749",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-942-3255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0a9-72fa-a225-ebe5ae6b439e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0a9-72fa-a225-ebe5ae6b439e",
        "storage_key": "property/6767906449167593/019fc927-d0a9-72fa-a225-ebe5ae6b439e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJS0g-XrXpwIcRyw3Y1fOzktA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_409d1a8a-c169-4e71-a182-46c022e1021a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "AMC Ward Parkway 14",
      "poi_type": "Entertainment",
      "poi_address": "8600 Ward Pkwy Ste 14, Kansas City, MO 64114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-116f-746f-9d7e-549d1fbd421d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc92b-116f-746f-9d7e-549d1fbd421d",
        "storage_key": "property/6767906449167593/019fc92b-116f-746f-9d7e-549d1fbd421d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/kansas-city/amc-ward-parkway-14?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=4324502177671408215&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-ward-parkway-14",
      "poi_latitude": "38.9708735",
      "poi_longitude": "-94.6062666",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-333-1300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-48f3-76fd-ae9f-3010361354a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc92b-48f3-76fd-ae9f-3010361354a0",
        "storage_key": "property/6767906449167593/019fc92b-48f3-76fd-ae9f-3010361354a0.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJda3_VSbpwIcRV-qBgtG3Azw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_47e60797-7cbc-4308-9510-ad04c8093cce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Screenland Armour Theatre",
      "poi_type": "Entertainment",
      "poi_address": "408 Armour Rd, North Kansas City, MO 64116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101a-a5e5-71fa-a610-06e277e1a233.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-a5e5-71fa-a610-06e277e1a233",
        "storage_key": "property/6767906449167593/01a0101a-a5e5-71fa-a610-06e277e1a233.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.screenland.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16359549647935901976&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "screenland-armour-theatre",
      "poi_latitude": "39.142568",
      "poi_longitude": "-94.575699",
      "poi_miles_from_property": "15",
      "poi_walking_minutes": "5 hours 37 mins",
      "poi_biking_minutes": "1 hour 37 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 816-994-7380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-48f3-76fd-ae9f-3010361354a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc92b-48f3-76fd-ae9f-3010361354a0",
        "storage_key": "property/6767906449167593/019fc92b-48f3-76fd-ae9f-3010361354a0.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJIYxzebHwwIcRGBGWarrLCOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_d0f61715-a750-4c0f-bdcc-549f5bcfdb2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "B&B Theatres KC Extreme Screen Union Station",
      "poi_type": "Entertainment",
      "poi_address": "30 W Pershing Rd, Kansas City, MO 64108, USA",
      "poi_short_description": "Family-run movie theater in a train station, known for its 80-by-53-foot screen with 3D capability.",
      "poi_long_description": "Family-run movie theater in a train station, known for its 80-by-53-foot screen with 3D capability.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101a-a5d4-7568-9569-cd0adecbc42e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-a5d4-7568-9569-cd0adecbc42e",
        "storage_key": "property/6767906449167593/01a0101a-a5d4-7568-9569-cd0adecbc42e.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "https://extremescreen.unionstation.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16333279347611528106&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bb-theatres-kc-extreme-screen-union-station",
      "poi_latitude": "39.0848525",
      "poi_longitude": "-94.5860392",
      "poi_miles_from_property": "11.1",
      "poi_walking_minutes": "4 hours 9 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 816-460-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-48f3-76fd-ae9f-3010361354a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc92b-48f3-76fd-ae9f-3010361354a0",
        "storage_key": "property/6767906449167593/019fc92b-48f3-76fd-ae9f-3010361354a0.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJp391fz_wwIcRquubewd3q-I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_00245dd1-8ce0-4127-9620-8708f2a0b61b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Starlight Theatre",
      "poi_type": "Entertainment",
      "poi_address": "4600 Starlight Rd, Kansas City, MO 64132, USA",
      "poi_short_description": "Iconic outdoor theater in Swope Park hosting Broadway shows, rock concerts & other productions.",
      "poi_long_description": "Iconic outdoor theater in Swope Park hosting Broadway shows, rock concerts & other productions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-19be-7222-a851-32a4193fe2d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc92b-19be-7222-a851-32a4193fe2d5",
        "storage_key": "property/6767906449167593/019fc92b-19be-7222-a851-32a4193fe2d5.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "https://www.kcstarlight.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12152994064738864795&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starlight-theatre",
      "poi_latitude": "39.00745440000001",
      "poi_longitude": "-94.5328221",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 816-363-7827",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0ab-7293-beda-8a585de8eebc",
        "storage_key": "property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg_zL1bnlwIcRm84warYbqKg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_401e0f82-e9d7-4102-bb8b-135453f1b982",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Kansas City Zoo & Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "6800 Zoo Dr, Kansas City, MO 64132, USA",
      "poi_short_description": "Zoo in Swope Park with zookeepers offering animal interaction & informative chats.",
      "poi_long_description": "Zoo in Swope Park with zookeepers offering animal interaction & informative chats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-b050-7289-a474-c2b197172c60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc927-b050-7289-a474-c2b197172c60",
        "storage_key": "property/6767906449167593/019fc927-b050-7289-a474-c2b197172c60.webp",
        "width": 680,
        "height": 473
      },
      "poi_business_url": "https://www.kansascityzoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12992684715297648381&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-zoo--aquarium",
      "poi_latitude": "39.0072568",
      "poi_longitude": "-94.5293443",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 816-595-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0ab-7293-beda-8a585de8eebc",
        "storage_key": "property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAaCDFcrlwIcR_a72DelJT7Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_923b764c-6b39-4d78-81f6-2b64fcb0789e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "The Nelson-Atkins Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "4525 Oak St, Kansas City, MO 64111, USA",
      "poi_short_description": "Art collection spanning 5,000 years in neoclassical & modern galleries, plus a sculpture garden.",
      "poi_long_description": "Art collection spanning 5,000 years in neoclassical & modern galleries, plus a sculpture garden.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-154c-7229-96e5-1ee85f035a7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc92b-154c-7229-96e5-1ee85f035a7a",
        "storage_key": "property/6767906449167593/019fc92b-154c-7229-96e5-1ee85f035a7a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nelson-atkins.org/?utm_source=gmb&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=3122843275976164549&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-nelson-atkins-museum-of-art",
      "poi_latitude": "39.0449506",
      "poi_longitude": "-94.5809284",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 816-751-1278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0aa-769f-a4f0-117a74d67a84.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0aa-769f-a4f0-117a74d67a84",
        "storage_key": "property/6767906449167593/019fc927-d0aa-769f-a4f0-117a74d67a84.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJRSCf3ervwIcRxcTG-WmRVis",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_0126d43b-7102-437c-aefd-38178f44d18c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "National WWI Museum and Memorial",
      "poi_type": "Entertainment",
      "poi_address": "2 Memorial Dr, Kansas City, MO 64108, USA",
      "poi_short_description": "The nation's only public museum dedicated to WWI, with a large collection of photos, weapons & more.",
      "poi_long_description": "The nation's only public museum dedicated to WWI, with a large collection of photos, weapons & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101a-a7c3-74b8-9b4e-d19d00580579.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-a7c3-74b8-9b4e-d19d00580579",
        "storage_key": "property/6767906449167593/01a0101a-a7c3-74b8-9b4e-d19d00580579.webp",
        "width": 1280,
        "height": 1071
      },
      "poi_business_url": "https://www.theworldwar.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10469991631701161311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "national-wwi-museum-and-memorial",
      "poi_latitude": "39.080663",
      "poi_longitude": "-94.5860835",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "3 hours 54 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 816-888-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0aa-769f-a4f0-117a74d67a84.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0aa-769f-a4f0-117a74d67a84",
        "storage_key": "property/6767906449167593/019fc927-d0aa-769f-a4f0-117a74d67a84.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJpzAyJjzwwIcRXzXcqOrhTJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_6af115a0-45d0-4050-aefc-3bc0d7a3d48e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "SEA LIFE Kansas City Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "2475 Grand Blvd Ste 100, Kansas City, MO 64108, USA",
      "poi_short_description": "Family-friendly exhibits featuring more than 5,000 sea creatures, plus a play area & group packages.",
      "poi_long_description": "Family-friendly exhibits featuring more than 5,000 sea creatures, plus a play area & group packages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-1434-76d9-b1ac-d99f2ad94814.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc92b-1434-76d9-b1ac-d99f2ad94814",
        "storage_key": "property/6767906449167593/019fc92b-1434-76d9-b1ac-d99f2ad94814.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.visitsealife.com/kansas-city/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=5590252280065768693&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sea-life-kansas-city-aquarium",
      "poi_latitude": "39.0820805",
      "poi_longitude": "-94.5812573",
      "poi_miles_from_property": "10.5",
      "poi_walking_minutes": "3 hours 56 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 816-471-4386",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-48e9-741d-809e-adde1a155f37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc92b-48e9-741d-809e-adde1a155f37",
        "storage_key": "property/6767906449167593/019fc92b-48e9-741d-809e-adde1a155f37.webp",
        "width": 192,
        "height": 176
      },
      "poi_google_place_id": "ChIJtyRwuxXwwIcR9TwjjtSQlE0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_87596ca8-a024-48e0-97cc-6f506de489ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Kauffman Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "1601 Broadway Blvd, Kansas City, MO 64108, USA",
      "poi_short_description": "2 performance halls joined together under a glass dome, hosting music, opera, theater & dance.",
      "poi_long_description": "2 performance halls joined together under a glass dome, hosting music, opera, theater & dance.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-17a0-72d8-9932-bb9af9c7af72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc92b-17a0-72d8-9932-bb9af9c7af72",
        "storage_key": "property/6767906449167593/019fc92b-17a0-72d8-9932-bb9af9c7af72.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kauffmancenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6371724031435486048&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kauffman-center-for-the-performing-arts",
      "poi_latitude": "39.0941068",
      "poi_longitude": "-94.5876247",
      "poi_miles_from_property": "11.4",
      "poi_walking_minutes": "4 hours 18 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 816-994-7222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0ab-7293-beda-8a585de8eebc",
        "storage_key": "property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ99d4bkPwwIcRYDOIbD_pbFg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_0ce4fa5b-0e15-4ca3-8292-8a6df06dcf7e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "T-Mobile Center",
      "poi_type": "Entertainment",
      "poi_address": "1407 Grand Blvd, Kansas City, MO 64106, USA",
      "poi_short_description": "Indoor arena with nearly 20,000 seats hosts pro & college sporting events, big-name concerts & more.",
      "poi_long_description": "Indoor arena with nearly 20,000 seats hosts pro & college sporting events, big-name concerts & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101a-a8ed-73dc-9558-fd6ce98c8c83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-a8ed-73dc-9558-fd6ce98c8c83",
        "storage_key": "property/6767906449167593/01a0101a-a8ed-73dc-9558-fd6ce98c8c83.webp",
        "width": 1280,
        "height": 881
      },
      "poi_business_url": "http://www.t-mobilecenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12445204140955467076&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "t-mobile-center",
      "poi_latitude": "39.0974667",
      "poi_longitude": "-94.5801529",
      "poi_miles_from_property": "11.5",
      "poi_walking_minutes": "4 hours 19 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 816-949-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0ab-7293-beda-8a585de8eebc",
        "storage_key": "property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi31tv2fwwIcRRP3eijo_tqw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_c84dc1a7-6075-4394-89be-086527baf949",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "St. Joseph Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1000 Carondelet Dr, Kansas City, MO 64114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-1deb-772a-b4d2-131366d3313a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc92b-1deb-772a-b4d2-131366d3313a",
        "storage_key": "property/6767906449167593/019fc92b-1deb-772a-b4d2-131366d3313a.webp",
        "width": 1280,
        "height": 759
      },
      "poi_business_url": "https://stjosephkc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7339372022043256229&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-joseph-medical-center",
      "poi_latitude": "38.9367761",
      "poi_longitude": "-94.6044651",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-942-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0aa-769f-a4f0-14ec79dca032.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0aa-769f-a4f0-14ec79dca032",
        "storage_key": "property/6767906449167593/019fc927-d0aa-769f-a4f0-14ec79dca032.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJj9D8LlXowIcRpSVU6Pev2mU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_d14893b3-ddf5-4bb1-aa25-284207694cf1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Saint Luke's Hospital of Kansas City",
      "poi_type": "Health and Wellness",
      "poi_address": "4401 Wornall Rd, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019ff6c3-ac8b-7265-9afa-76898324b0dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c3-ac8b-7265-9afa-76898324b0dd",
        "storage_key": "property/6767906449167593/019ff6c3-ac8b-7265-9afa-76898324b0dd.webp",
        "width": 1280,
        "height": 937
      },
      "poi_business_url": "http://www.saintlukeskc.org/locations/saint-lukes-hospital-kansas-city?utm_source=yext&utm_medium=local_listing&utm_campaign=yext_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4012580085298393479&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-lukes-hospital-of-kansas-city",
      "poi_latitude": "39.0460972",
      "poi_longitude": "-94.58992940000002",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 816-932-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0aa-769f-a4f0-14ec79dca032.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0aa-769f-a4f0-14ec79dca032",
        "storage_key": "property/6767906449167593/019fc927-d0aa-769f-a4f0-14ec79dca032.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJJembMcTvwIcRh3EE-VOMrzc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_e4e4f4e2-82de-4e19-b2dd-781307e30d88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Encompass Medical Group Wornall Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "373 W 101st Terrace, Kansas City, MO 64114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019ff6c3-996a-73ab-85ef-bd63ecef26df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c3-996a-73ab-85ef-bd63ecef26df",
        "storage_key": "property/6767906449167593/019ff6c3-996a-73ab-85ef-bd63ecef26df.webp",
        "width": 1165,
        "height": 1280
      },
      "poi_business_url": "https://encompassmed.com/locations/kansas-city-wornall-office/",
      "poi_directions_map_url": "https://maps.google.com/?cid=44019085564346490&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "encompass-medical-group-wornall-clinic",
      "poi_latitude": "38.9435625",
      "poi_longitude": "-94.5951648",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-942-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0ab-7293-beda-8a585de8eebc",
        "storage_key": "property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvbkakfnowIcReoBmBiBjnAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_5be89d8a-f5cb-4734-b863-3ca6d1f163f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "CareNow Urgent Care - State Line Road",
      "poi_type": "Health and Wellness",
      "poi_address": "8951 State Line Rd, Kansas City, MO 64114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-1df4-7573-9e24-e9ff7b908f71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc92b-1df4-7573-9e24-e9ff7b908f71",
        "storage_key": "property/6767906449167593/019fc92b-1df4-7573-9e24-e9ff7b908f71.webp",
        "width": 616,
        "height": 346
      },
      "poi_business_url": "https://www.carenow.com/locations/kansas-city/state-line-road?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=3516147410637542177&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---state-line-road",
      "poi_latitude": "38.9666938",
      "poi_longitude": "-94.6078338",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-443-0089",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0ab-7293-beda-8a585de8eebc",
        "storage_key": "property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6Xzm7WrpwIcRIdP1zHDdyzA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_81e6f31a-b5c8-470a-8e52-c035d03ba0d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Carbon Health Urgent Care Kansas City - Ward Parkway Mall",
      "poi_type": "Health and Wellness",
      "poi_address": "8600 Ward Pkwy #1019, Kansas City, MO 64114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-21f9-7063-83cc-d4cbcf1dfa27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc92b-21f9-7063-83cc-d4cbcf1dfa27",
        "storage_key": "property/6767906449167593/019fc92b-21f9-7063-83cc-d4cbcf1dfa27.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://carbonhealth.com/locations/kansas-city-mo-ward-parkway-mall?utm_source=gmb&utm_medium=referral&utm_campaign=kansas-city&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=14918933100147359335&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carbon-health-urgent-care-kansas-city---ward-parkway-mall",
      "poi_latitude": "38.97075359999999",
      "poi_longitude": "-94.6067878",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 417-822-5933",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0ab-7293-beda-8a585de8eebc",
        "storage_key": "property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ96BWLhLpwIcRZ74ZVpyyCs8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_e94c7ce8-8914-4b1f-9138-a4a0cb5484f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "City Gym KC",
      "poi_type": "Health and Wellness",
      "poi_address": "7416 Wornall Rd, Kansas City, MO 64114, USA",
      "poi_short_description": "Clean local gym featuring group classes, free weights, cardio equipment, and friendly staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101a-b06f-757f-aa40-0f50d0750ae0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-b06f-757f-aa40-0f50d0750ae0",
        "storage_key": "property/6767906449167593/01a0101a-b06f-757f-aa40-0f50d0750ae0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.citygymkc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8719845166897936275&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-gym-kc",
      "poi_latitude": "38.9933167",
      "poi_longitude": "-94.5945946",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-326-8790",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0ab-7293-beda-8a585de8eebc",
        "storage_key": "property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjTw3OyXvwIcRk7dbxfocA3k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4f2d6390-8dfe-46ef-8e34-51595d19b6dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Rare Breed Athletics",
      "poi_type": "Health and Wellness",
      "poi_address": "300 W 80th St, Kansas City, MO 64114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101a-ac6b-77bc-8f8a-0dc5e6b5d9c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-ac6b-77bc-8f8a-0dc5e6b5d9c2",
        "storage_key": "property/6767906449167593/01a0101a-ac6b-77bc-8f8a-0dc5e6b5d9c2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rarebreedcfathletics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3554912864853511250&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rare-breed-athletics",
      "poi_latitude": "38.9836037",
      "poi_longitude": "-94.5931581",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-398-3817",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0ab-7293-beda-8a585de8eebc",
        "storage_key": "property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAW9ovBHvwIcRUkwPdWqWVTE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_bd39738d-0320-4482-9546-6751368dab39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Arbor Vitae Yoga and Wellness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "7235 Central St, Kansas City, MO 64114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101a-ac86-733c-b00c-db8a62e12c6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-ac86-733c-b00c-db8a62e12c6c",
        "storage_key": "property/6767906449167593/01a0101a-ac86-733c-b00c-db8a62e12c6c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.arborvitaekc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8209937512169292087&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arbor-vitae-yoga-and-wellness-center",
      "poi_latitude": "38.9964592",
      "poi_longitude": "-94.5924407",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-268-4660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0ab-7293-beda-8a585de8eebc",
        "storage_key": "property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9QPNWDvvwIcRN0EBUauO73E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wellness_center"
    },
    {
      "id": "custom_29fb9a07-ae86-434c-b6d8-9139de0db823",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Watts Mill Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1101 103rd St, Kansas City, MO 64114, USA",
      "poi_short_description": "Park featuring a waterfall, picnic tables, and a restroom, plus signs about the site's history as a mill.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-2427-709c-a575-3aee05ba13b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc92b-2427-709c-a575-3aee05ba13b2",
        "storage_key": "property/6767906449167593/019fc92b-2427-709c-a575-3aee05ba13b2.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5041682459638612630&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "watts-mill-park",
      "poi_latitude": "38.9416118",
      "poi_longitude": "-94.605157",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0b5-724a-805c-7f7998fe6328.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0b5-724a-805c-7f7998fe6328",
        "storage_key": "property/6767906449167593/019fc927-d0b5-724a-805c-7f7998fe6328.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSTgo1XjpwIcRlsITLXyn90U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2920585a-8f95-46a2-acd5-3d2d6f4930e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Sunnyside Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8255 Summit St, Kansas City, MO 64114, USA",
      "poi_short_description": "Neighborhood park with a children's pool and fountain, playground, and picnic area, plus tennis, baseball, and basketball courts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019ff6c3-a274-748f-8a39-431c98bcef93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c3-a274-748f-8a39-431c98bcef93",
        "storage_key": "property/6767906449167593/019ff6c3-a274-748f-8a39-431c98bcef93.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://kcparks.org/places/sunnyside-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8092414730922481775&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunnyside-park",
      "poi_latitude": "38.9787587",
      "poi_longitude": "-94.5977782",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-513-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0b5-724a-805c-7f7998fe6328.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0b5-724a-805c-7f7998fe6328",
        "storage_key": "property/6767906449167593/019fc927-d0b5-724a-805c-7f7998fe6328.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJv_bamtPowIcRb9jFg1IITnA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_42acc535-88c0-45f8-9fb5-b248569d5ad7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Leawood City Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10601 Lee Blvd, Leawood, KS 66206, USA",
      "poi_short_description": "Public park with a playground, trails, pool, tennis courts, sports fields, and an off-leash area for dogs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-c737-717f-97bc-18495f5f58df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc927-c737-717f-97bc-18495f5f58df",
        "storage_key": "property/6767906449167593/019fc927-c737-717f-97bc-18495f5f58df.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.leawood.org",
      "poi_directions_map_url": "https://maps.google.com/?cid=11472992157373923685&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "leawood-city-park",
      "poi_latitude": "38.9308908",
      "poi_longitude": "-94.6190568",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-339-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0b5-724a-805c-7f7998fe6328.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0b5-724a-805c-7f7998fe6328",
        "storage_key": "property/6767906449167593/019fc927-d0b5-724a-805c-7f7998fe6328.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_1CEy6XpwIcRZYEdo5RBOJ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6ff1e2e7-060e-48fb-9ba7-3ba7cebbd8f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Minor Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11103 Holmes Rd, Kansas City, MO 64131, USA",
      "poi_short_description": "A former farm, this 235-acre park is now a public green space with picnic areas & a golf course.",
      "poi_long_description": "A former farm, this 235-acre park is now a public green space with picnic areas & a golf course.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019ff6c3-a26d-77aa-af03-fdd820f68239.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c3-a26d-77aa-af03-fdd820f68239",
        "storage_key": "property/6767906449167593/019ff6c3-a26d-77aa-af03-fdd820f68239.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://kcparks.org/park/minor-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4334434506848058412&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "minor-park",
      "poi_latitude": "38.9200461",
      "poi_longitude": "-94.5702082",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-942-4033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0b5-724a-805c-7f7998fe6328.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0b5-724a-805c-7f7998fe6328",
        "storage_key": "property/6767906449167593/019fc927-d0b5-724a-805c-7f7998fe6328.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJbQ_5VGzowIcRLLzfGjgBJzw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a90b04b7-5388-4c51-a72d-ab041c843047",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Blue River Park and Athletic Fields",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Kansas City, MO 64131, USA",
      "poi_short_description": "City park with an athletic field and opportunities for kid-friendly hiking.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019ff6c3-9ef0-72c9-aca5-ce778bf79090.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c3-9ef0-72c9-aca5-ce778bf79090",
        "storage_key": "property/6767906449167593/019ff6c3-9ef0-72c9-aca5-ce778bf79090.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://kcparks.org/park/blue-river-athletic-field/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17433770348333043942&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-river-park-and-athletic-fields",
      "poi_latitude": "38.9364127",
      "poi_longitude": "-94.5650661",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-513-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0b5-724a-805c-7f7998fe6328.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0b5-724a-805c-7f7998fe6328",
        "storage_key": "property/6767906449167593/019fc927-d0b5-724a-805c-7f7998fe6328.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ1_l337owIcR5hAhhMMx8fE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_35e1138b-09b6-40b4-944d-82f6882506ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Tower Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7500 Holmes Rd, Kansas City, MO 64131, USA",
      "poi_short_description": "City park with a playground, picnic tables, barbecue grills, and baseball fields.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101a-b506-73e5-9e08-72215b07651d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-b506-73e5-9e08-72215b07651d",
        "storage_key": "property/6767906449167593/01a0101a-b506-73e5-9e08-72215b07651d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://kcparks.org/places/tower-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13027604694439253819&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tower-park",
      "poi_latitude": "38.9890787",
      "poi_longitude": "-94.5815761",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-513-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0b5-724a-805c-7f7998fe6328.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0b5-724a-805c-7f7998fe6328",
        "storage_key": "property/6767906449167593/019fc927-d0b5-724a-805c-7f7998fe6328.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJF9IwHffvwIcRO1dDRnJZy7Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_d05fee41-afc2-48a3-820c-0c9c2582dfa5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Swope Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3999 Swope Pkwy &, 3999 E Meyer Blvd, Kansas City, MO 64132, USA",
      "poi_short_description": "1,805-acre park with community gardens, a golf course & 9 soccer fields, plus a theater & zoo.",
      "poi_long_description": "1,805-acre park with community gardens, a golf course & 9 soccer fields, plus a theater & zoo.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-c74e-7133-9489-d9901ce134e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc927-c74e-7133-9489-d9901ce134e4",
        "storage_key": "property/6767906449167593/019fc927-c74e-7133-9489-d9901ce134e4.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://kcparks.org/park/swope-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=787846344043871735&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "swope-park",
      "poi_latitude": "39.0078385",
      "poi_longitude": "-94.5347889",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 816-513-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0b5-724a-805c-7f7998fe6328.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0b5-724a-805c-7f7998fe6328",
        "storage_key": "property/6767906449167593/019fc927-d0b5-724a-805c-7f7998fe6328.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJXWMkZXlwIcR9z1TYhP-7go",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5cf088e8-aace-43fe-9ce4-159b1706fd68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Carl Migliazzo Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Minor Dr &, Pennsylvania Ave, Kansas City, MO 64145, USA",
      "poi_short_description": "City park offering a playground, picnic tables, and fishing in a small pond.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019ff6c3-a7e3-73c7-8a79-975c5f325cfa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c3-a7e3-73c7-8a79-975c5f325cfa",
        "storage_key": "property/6767906449167593/019ff6c3-a7e3-73c7-8a79-975c5f325cfa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://kcparks.org/places/carl-migliazzo-park-2/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5819787493430107038&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carl-migliazzo-park",
      "poi_latitude": "38.9109671",
      "poi_longitude": "-94.6004969",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-513-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0b5-724a-805c-7f7998fe6328.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0b5-724a-805c-7f7998fe6328",
        "storage_key": "property/6767906449167593/019fc927-d0b5-724a-805c-7f7998fe6328.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJXY5oDPowIcRnpspBuQJxFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_9e4c5f7c-8516-4577-9ca8-a4fdde1b0b20",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Prairie Oak Nature Center-Leawood KS",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3640 Ironwoods Ct, Leawood, KS 66224, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101a-b6af-769a-b3d2-7efc6352a6f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-b6af-769a-b3d2-7efc6352a6f5",
        "storage_key": "property/6767906449167593/01a0101a-b6af-769a-b3d2-7efc6352a6f5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.leawood.org/parks-and-recreation/outdoor-education-and-recreation/prairie-oak-nature-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13919241413194241449&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prairie-oak-nature-center-leawood-ks",
      "poi_latitude": "38.858942",
      "poi_longitude": "-94.625304",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 913-696-7770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0b5-724a-805c-7f7998fe6328.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0b5-724a-805c-7f7998fe6328",
        "storage_key": "property/6767906449167593/019fc927-d0b5-724a-805c-7f7998fe6328.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0S91D0rCwIcRqVVZaFEUK8E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3050d121-efd1-4091-9ebc-20513aa05f01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Three Trails Transit Ctr Southbound Lane",
      "poi_type": "Transportation & Transit",
      "poi_address": "Kansas City, MO 64138, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-3636-70fb-b01b-3dbf611ebfa9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc92b-3636-70fb-b01b-3dbf611ebfa9",
        "storage_key": "property/6767906449167593/019fc92b-3636-70fb-b01b-3dbf611ebfa9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11578073823919471817&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "three-trails-transit-ctr-southbound-lane",
      "poi_latitude": "38.953192",
      "poi_longitude": "-94.507295",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-4907-738b-a22d-1256cc04569c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc92b-4907-738b-a22d-1256cc04569c",
        "storage_key": "property/6767906449167593/019fc92b-4907-738b-a22d-1256cc04569c.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJeTIM9uXmwIcRyfz3scyUraA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_c480b04a-5dd7-4e76-90d4-44708abffe7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Alphapointe",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7501 Prospect Ave, Kansas City, MO 64132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-3a73-75fa-b040-12b1c7f2e826.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc92b-3a73-75fa-b040-12b1c7f2e826",
        "storage_key": "property/6767906449167593/019fc92b-3a73-75fa-b040-12b1c7f2e826.webp",
        "width": 1280,
        "height": 838
      },
      "poi_business_url": "http://www.alphapointe.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10019712522138751265&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alphapointe",
      "poi_latitude": "38.98964429999999",
      "poi_longitude": "-94.5556366",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 816-421-5848",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0ab-7293-beda-8a585de8eebc",
        "storage_key": "property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjYPjmPvlwIcRIRGdwXMrDYs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_ffce659d-b107-476c-84af-f51a3bb87115",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "8600 N Boardwalk Ave Parking",
      "poi_type": "Transportation & Transit",
      "poi_address": "8600 N Boardwalk Ave, Kansas City, MO 64154, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12959570217703543379&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "8600-n-boardwalk-ave-parking",
      "poi_latitude": "39.251945",
      "poi_longitude": "-94.6564775",
      "poi_miles_from_property": "25.5",
      "poi_walking_minutes": "9 hours 37 mins",
      "poi_biking_minutes": "2 hours 43 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 816-221-0660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-4b77-74ba-b825-f0af097efb71.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc92b-4b77-74ba-b825-f0af097efb71",
        "storage_key": "property/6767906449167593/019fc92b-4b77-74ba-b825-f0af097efb71.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJHdX4xjlfwIcRU5LzQ3Ok2bM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_f51b61b8-4a8f-4e53-baa8-b8269a275f44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "East Village Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "700 E 12th St, Kansas City, MO 64106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101a-b71e-7759-af52-e45e283dea9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-b71e-7759-af52-e45e283dea9e",
        "storage_key": "property/6767906449167593/01a0101a-b71e-7759-af52-e45e283dea9e.webp",
        "width": 598,
        "height": 1280
      },
      "poi_business_url": "http://ridekc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16512695178041122718&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "east-village-transit-center",
      "poi_latitude": "39.0994481",
      "poi_longitude": "-94.5736732",
      "poi_miles_from_property": "11.8",
      "poi_walking_minutes": "4 hours 28 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 816-221-0660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0ab-7293-beda-8a585de8eebc",
        "storage_key": "property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVzzDLhPxwIcRnl9yw8bgKOU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_40b2c9ce-6cec-40a4-953a-93a798f2259c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Metro Center (12th & Main St)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Kansas City, MO 64105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-3948-72f8-ac28-26ab56d1fa3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc92b-3948-72f8-ac28-26ab56d1fa3a",
        "storage_key": "property/6767906449167593/019fc92b-3948-72f8-ac28-26ab56d1fa3a.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://ridekc.org/assets/uploads/route-maps/Streetcarmwk.jpg",
      "poi_directions_map_url": "https://maps.google.com/?cid=13899610975165952526&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "metro-center-12th--main-st",
      "poi_latitude": "39.099829",
      "poi_longitude": "-94.583256",
      "poi_miles_from_property": "11.6",
      "poi_walking_minutes": "4 hours 22 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-4b67-714a-a920-6e302e12c3f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc92b-4b67-714a-a920-6e302e12c3f2",
        "storage_key": "property/6767906449167593/019fc92b-4b67-714a-a920-6e302e12c3f2.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJQS3Y9F3wwIcRDjLj4olW5cA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tram_stop"
    },
    {
      "id": "custom_f8970592-10cf-452e-89e4-c0e3073f9433",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Kansas City",
      "poi_type": "Transportation & Transit",
      "poi_address": "30 W Pershing Rd Union Station, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-3825-773f-b1d8-876de6ea6fdf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc92b-3825-773f-b1d8-876de6ea6fdf",
        "storage_key": "property/6767906449167593/019fc92b-3825-773f-b1d8-876de6ea6fdf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=KCY",
      "poi_directions_map_url": "https://maps.google.com/?cid=3787247529242741214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city",
      "poi_latitude": "39.0847966",
      "poi_longitude": "-94.5853578",
      "poi_miles_from_property": "10.6",
      "poi_walking_minutes": "3 hours 58 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-4b3a-736e-b504-02e46fa55c92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc92b-4b3a-736e-b504-02e46fa55c92",
        "storage_key": "property/6767906449167593/019fc92b-4b3a-736e-b504-02e46fa55c92.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJxbu2nD_wwIcR3kn96I8BjzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_2dbc55f3-88b9-4015-b8e1-d03867b2d5ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Greyhound: Bus Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1101 Troost Ave, Kansas City, MO 64106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-3836-775d-8feb-91ab195f757a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc92b-3836-775d-8feb-91ab195f757a",
        "storage_key": "property/6767906449167593/019fc92b-3836-775d-8feb-91ab195f757a.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.greyhound.com/bus/kansas-city-mo/kansas-city-bus-station?utm_source=google_maps&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=16685443334022975407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-station",
      "poi_latitude": "39.1000335",
      "poi_longitude": "-94.5693013",
      "poi_miles_from_property": "12.1",
      "poi_walking_minutes": "4 hours 32 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0ab-7293-beda-8a585de8eebc",
        "storage_key": "property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWy-YvXvwwIcRr09ZHE-ajuc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_b9aa701c-faf0-4509-a6c6-d513d9e4d0e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Kansas City International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Kansas City Blvd, Kansas City, MO 64153, USA",
      "poi_short_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_long_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-36b4-7144-a49a-8fd943b7096e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc92b-36b4-7144-a49a-8fd943b7096e",
        "storage_key": "property/6767906449167593/019fc92b-36b4-7144-a49a-8fd943b7096e.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.flykc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14109162014977743520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-international-airport",
      "poi_latitude": "39.3014091",
      "poi_longitude": "-94.7104536",
      "poi_miles_from_property": "32.7",
      "poi_walking_minutes": "12 hours 14 mins",
      "poi_biking_minutes": "3 hours 54 mins",
      "poi_driving_minutes": "39 mins",
      "poi_business_phone": "+1 816-243-5237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-4b5f-725c-96b1-56141b03ba91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc92b-4b5f-725c-96b1-56141b03ba91",
        "storage_key": "property/6767906449167593/019fc92b-4b5f-725c-96b1-56141b03ba91.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYfmiAhewIcRoNouXRnQzcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_6deb0e99-6253-4dde-ba86-d2f8bc70ca40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Metro Transit Center (O)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Independence, MO 64050, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3591687130881227423&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "metro-transit-center-o",
      "poi_latitude": "39.0941",
      "poi_longitude": "-94.412994",
      "poi_miles_from_property": "19.1",
      "poi_walking_minutes": "7 hours 7 mins",
      "poi_biking_minutes": "1 hour 53 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-4b67-714a-a920-6e302e12c3f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc92b-4b67-714a-a920-6e302e12c3f2",
        "storage_key": "property/6767906449167593/019fc92b-4b67-714a-a920-6e302e12c3f2.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJm-FAh2n9wIcRn3qEfGo82DE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_89b1887b-9a6f-4f49-9750-b8ea157b2a1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Midwest Trust Center",
      "poi_type": "Entertainment",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "Performing-arts center hosting a variety of concerts, dance performances & film screenings.",
      "poi_long_description": "Performing-arts center hosting a variety of concerts, dance performances & film screenings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-3a79-76a7-95f0-64ac096a0798.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc92b-3a79-76a7-95f0-64ac096a0798",
        "storage_key": "property/6767906449167593/019fc92b-3a79-76a7-95f0-64ac096a0798.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.jccc.edu/midwest-trust-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=333406106616415315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midwest-trust-center",
      "poi_latitude": "38.9252624",
      "poi_longitude": "-94.7279145",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-469-4445",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0ab-7293-beda-8a585de8eebc",
        "storage_key": "property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVtOx9LqwIcRU0TRZhZ_oAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_dd9bb7f8-2a95-457f-9f47-63a13e75e72c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Research Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2316 E Meyer Blvd Entrance A, Kansas City, MO 64132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-1d16-7377-917a-915bea2296ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc92b-1d16-7377-917a-915bea2296ac",
        "storage_key": "property/6767906449167593/019fc92b-1d16-7377-917a-915bea2296ac.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hcamidwest.com/locations/research-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=2531637298813944464&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "research-medical-center",
      "poi_latitude": "39.0097259",
      "poi_longitude": "-94.5592068",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 816-276-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0aa-769f-a4f0-14ec79dca032.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0aa-769f-a4f0-14ec79dca032",
        "storage_key": "property/6767906449167593/019fc927-d0aa-769f-a4f0-14ec79dca032.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJoS-DyIvlwIcRkELvx7UuIiM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_99109a95-2d3d-4fd5-9423-2c78ae6f8d28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "University Health Truman Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2301 Holmes St, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019ff6c3-a971-7609-be2a-16b31ed95018.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c3-a971-7609-be2a-16b31ed95018",
        "storage_key": "property/6767906449167593/019ff6c3-a971-7609-be2a-16b31ed95018.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.universityhealthkc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3094198644431175220&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-health-truman-medical-center",
      "poi_latitude": "39.0841581",
      "poi_longitude": "-94.5752125",
      "poi_miles_from_property": "10.8",
      "poi_walking_minutes": "4 hours 2 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 816-404-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0aa-769f-a4f0-14ec79dca032.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0aa-769f-a4f0-14ec79dca032",
        "storage_key": "property/6767906449167593/019fc927-d0aa-769f-a4f0-14ec79dca032.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJidv_PG3wwIcRNL7Q-UXN8Co",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_71c52163-c79d-47ae-94c5-2e3a403d6b07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Children's Mercy Adele Hall Campus",
      "poi_type": "Health and Wellness",
      "poi_address": "2401 Gillham Rd, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-4040-7348-90e8-2a475d36a8f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc92b-4040-7348-90e8-2a475d36a8f5",
        "storage_key": "property/6767906449167593/019fc92b-4040-7348-90e8-2a475d36a8f5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.childrensmercy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=241680805565643787&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-mercy-adele-hall-campus",
      "poi_latitude": "39.08387889999999",
      "poi_longitude": "-94.5771759",
      "poi_miles_from_property": "10.8",
      "poi_walking_minutes": "4 hours 3 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 816-234-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0aa-769f-a4f0-14ec79dca032.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0aa-769f-a4f0-14ec79dca032",
        "storage_key": "property/6767906449167593/019fc927-d0aa-769f-a4f0-14ec79dca032.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9zZsZRPwwIcRCzzFhGmfWgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_0f1824b2-d708-432c-8fd5-6376aa65fd1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "University of Missouri-Kansas City",
      "poi_type": "Education",
      "poi_address": "5000 Holmes St, Kansas City, MO 64110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-3d91-72e7-bd3b-04505b1b3792.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc92b-3d91-72e7-bd3b-04505b1b3792",
        "storage_key": "property/6767906449167593/019fc92b-3d91-72e7-bd3b-04505b1b3792.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.umkc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10660093312754521544&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-missouri-kansas-city",
      "poi_latitude": "39.0333035",
      "poi_longitude": "-94.577545",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 816-235-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0a9-72fa-a225-ebe5ae6b439e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0a9-72fa-a225-ebe5ae6b439e",
        "storage_key": "property/6767906449167593/019fc927-d0a9-72fa-a225-ebe5ae6b439e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ856Hn5DvwIcRyBVAa2NC8JM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_9fa9ff6e-bfdf-4a41-8119-4bc4e12607e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Hallmark Corporate",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2501 McGee St, Kansas City, MO 64108, USA",
      "poi_short_description": "Retail chain specializing in greeting cards, gift wrap, ornaments & gifts for all occasions.",
      "poi_long_description": "Retail chain specializing in greeting cards, gift wrap, ornaments & gifts for all occasions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-4330-720a-8ffa-5aaf5d67f245.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc92b-4330-720a-8ffa-5aaf5d67f245",
        "storage_key": "property/6767906449167593/019fc92b-4330-720a-8ffa-5aaf5d67f245.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://corporate.hallmark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1199437302719612463&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hallmark-corporate",
      "poi_latitude": "39.0811114",
      "poi_longitude": "-94.5800029",
      "poi_miles_from_property": "10.6",
      "poi_walking_minutes": "3 hours 59 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 800-425-5627",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0ab-7293-beda-8a585de8eebc",
        "storage_key": "property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjzp5phbwwIcRL4b0Nt9BpRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_24b8b963-c29a-4993-a1c0-747b9bc569b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Cerner Corporation - World Headquarters Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2800 Rock Creek Pkwy, Kansas City, MO 64117, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-40a5-75d8-8f27-8ad9a0a5482e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc92b-40a5-75d8-8f27-8ad9a0a5482e",
        "storage_key": "property/6767906449167593/019fc92b-40a5-75d8-8f27-8ad9a0a5482e.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.cerner.com/?utm_source=google&utm_medium=organic&utm_campaign=organic-local-listings&utm_content=whq-campus",
      "poi_directions_map_url": "https://maps.google.com/?cid=1107266875381616454&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cerner-corporation---world-headquarters-campus",
      "poi_latitude": "39.14986409999999",
      "poi_longitude": "-94.5459231",
      "poi_miles_from_property": "16.8",
      "poi_walking_minutes": "6 hours 20 mins",
      "poi_biking_minutes": "1 hour 48 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 816-221-1024",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0ab-7293-beda-8a585de8eebc",
        "storage_key": "property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJncA2l_X5wIcRRo-tSlvNXQ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_33e82799-ca84-4bea-bb4f-de31f613805f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "H&R Block",
      "poi_type": "Major Employers & Offices",
      "poi_address": "One H and R, Block Way, Kansas City, MO 64105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019ff6c3-ac48-7358-a6b9-25e65c5d980e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c3-ac48-7358-a6b9-25e65c5d980e",
        "storage_key": "property/6767906449167593/019ff6c3-ac48-7358-a6b9-25e65c5d980e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hrblock.com/tax-offices/local/missouri-tax-preparation/kansas-city-tax-professionals/?otppartnerid=9308&campaignid=pw_mcm_9308_9762&utm_medium=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=17520317420083081084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hr-block",
      "poi_latitude": "39.0982642",
      "poi_longitude": "-94.5829906",
      "poi_miles_from_property": "11.5",
      "poi_walking_minutes": "4 hours 19 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 816-854-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0ab-7293-beda-8a585de8eebc",
        "storage_key": "property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB8i63JCKwIcRfO8j8N2rJPM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_356b08a0-ae97-43ec-9ed0-df898e052c8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Lockton",
      "poi_type": "Major Employers & Offices",
      "poi_address": "444 W 47th St #900, Kansas City, MO 64112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101a-be56-7105-92ed-e5d3ec14527b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-be56-7105-92ed-e5d3ec14527b",
        "storage_key": "property/6767906449167593/01a0101a-be56-7105-92ed-e5d3ec14527b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://global.lockton.com/offices/us-kansas-city-headquarters",
      "poi_directions_map_url": "https://maps.google.com/?cid=2578382631270115552&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lockton",
      "poi_latitude": "39.0427697",
      "poi_longitude": "-94.59296100000002",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 816-960-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-d0ab-7293-beda-8a585de8eebc",
        "storage_key": "property/6767906449167593/019fc927-d0ab-7293-beda-8a585de8eebc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJObI1EbjvwIcR4Gjkn1dByCM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "insurance_agency"
    },
    {
      "id": "custom_059966b9-18cd-4e03-a8ca-d800d0a6172a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "custom",
      "poi_name": "Kansas City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Kansas City City Hall, 414 E 12th St, Kansas City, MO 64106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101a-bd9f-7775-b579-8323392bfc47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-bd9f-7775-b579-8323392bfc47",
        "storage_key": "property/6767906449167593/01a0101a-bd9f-7775-b579-8323392bfc47.webp",
        "width": 781,
        "height": 1280
      },
      "poi_business_url": "http://www.kcmo.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16264843786418924934&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-hall",
      "poi_latitude": "39.1008473",
      "poi_longitude": "-94.5780724",
      "poi_miles_from_property": "11.9",
      "poi_walking_minutes": "4 hours 30 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 816-513-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/019fc92b-4b8e-72e9-8363-fb6a2d06cc07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc92b-4b8e-72e9-8363-fb6a2d06cc07",
        "storage_key": "property/6767906449167593/019fc92b-4b8e-72e9-8363-fb6a2d06cc07.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_e-zp2bwwIcRhi24uD9VuOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    }
  ],
  "office_hours": [
    {
      "id": "ec_0692ffc1a5be67a9d952208f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_3993e94dfa00e512f476442a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_f66a6924598c06125c4e2d2b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_aec5390eabc7526f39af11c1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_14ecfa5dd475565d00099afe",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_5c796348108469b0d68a0e32",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_32ef2dcffbcc84d958b78ffe",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "rating": "5",
      "name": "Laurie Cichon",
      "text": "My husband an I have been here about 3 yrs. Not the best to start with under old management.  We have a New Manager his name is Nate an 2 Great ladies who work in the office as well. Miranda leasing person Sally Assistant Manager.  Nate has really turned this place around an still doing better stuff for our community here in Cloverset. We are now having gatherings at the clubhouse of different things they plan. Tonight was Hot Coco Bar. Wow was there the sweets with the Homemade Coco. There is Bingo, Reading Book Club an many other things planned. We now have Security an Security Cameras.  Things that need fixing gets fixed. Pet friendly. Buildings are being upgraded on the inside an outside. There is plans of other things going up outside for gatherings. Could be exciting😃😃 Neighbors lookout for each other. Take some time an come check a place out. Its a quite place an very peaceful. Tell them Lauie sent you lol Come check it out.",
      "date": "2026-02-18",
      "title": "false"
    },
    {
      "id": "ec_2f952d4de14c9167cc23b5a5",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "rating": "5",
      "name": "Penny Doshie",
      "text": "We have lived here going on a year and have absolutely have no complaints. Love our home and Cloverset team is on point. I highly recommend and continue to tell 55+ friend, this is the place to be!",
      "date": "2026-06-09",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_5a2be72f241888a30e6facf9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "A1 - 1 bed, 1 bath, 760 sqft.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101e-723a-753b-8c21-2982ff7312ad.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0101e-723a-753b-8c21-2982ff7312ad",
        "storage_key": "property/6767906449167593/01a0101e-723a-753b-8c21-2982ff7312ad.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Hawthorn (A1)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=v2zv3wKgGXT"
    },
    {
      "id": "ec_103fcc7a2341a3bced2bb4fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101e-712c-74bf-a0eb-283edc5963ec.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0101e-712c-74bf-a0eb-283edc5963ec",
        "storage_key": "property/6767906449167593/01a0101e-712c-74bf-a0eb-283edc5963ec.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Cedar (A2)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=rtH9Gx8ipa8"
    },
    {
      "id": "ec_90031747e83e6b3edec2a727",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101e-7441-7351-aae6-f8a8ad5b197d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0101e-7441-7351-aae6-f8a8ad5b197d",
        "storage_key": "property/6767906449167593/01a0101e-7441-7351-aae6-f8a8ad5b197d.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Sycamore (B1)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=QM7tTbQDMus"
    },
    {
      "id": "ec_97e2fc1ab6cfe8982aa9a2f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101e-71c7-779a-ab23-a6c0910ac1d7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0101e-71c7-779a-ab23-a6c0910ac1d7",
        "storage_key": "property/6767906449167593/01a0101e-71c7-779a-ab23-a6c0910ac1d7.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Birch (B2)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=PuQoT6FUSu3"
    },
    {
      "id": "ec_fa76798601d73fb38670d3ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167593/01a0101e-71e8-757a-ad2f-18e42f0bdf5a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0101e-71e8-757a-ad2f-18e42f0bdf5a",
        "storage_key": "property/6767906449167593/01a0101e-71e8-757a-ad2f-18e42f0bdf5a.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Monterey (B3)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Adgn54dhBSX"
    }
  ],
  "faqs": [
    {
      "id": "custom_9bec1cf6-7667-419c-96ac-8eb99c84dfc0",
      "question": "How do I apply?",
      "answer": "Click on the <a href=\"/apply-now\">Apply Now</a> button under the <a href=\"/floor-plans\">Floor Plans</a> tab of our community website.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_445049d8-2168-49de-92c9-785a030e8861",
      "question": "Are there different lease term options available?",
      "answer": "Yes, we offer various lease term options. Please <a href=\"/contact-us\">contact our office</a> for more details.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_96140449-6261-4ac2-a3f8-d4ee0c9b46f6",
      "question": "Do I need an appointment to take a tour?",
      "answer": "No appointment is necessary to tour our community during business hours; however, it is always appreciated if you call ahead to make sure we are available to provide adequate time for you to tour and ask questions. It is recommended to arrive no later than one half hour prior to closing if you would like to tour the community. Everyone over 18 years of age must have a valid photo ID to tour. Valid forms of identification are decided by Price Brothers Management Company and may include items such as: US Driver’s License, US State Photo ID, US Military Photo ID, US Visa with Photo ID upon it, US Citizenship and Immigration Services Photo ID, Passport.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_ebb089c1-73e1-4a7f-87d9-968027b86cc4",
      "question": "Do you allow pets?",
      "answer": "Our community is happy to accept cats and dogs. Please refer to our pet section on the <a href=\"/pet-policy\">Pet Policy</a> page.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_7011ad7d-1fb0-4d81-8441-d64f86c02a6c",
      "question": "Why does your pricing include ranges?",
      "answer": "The prices will range on each floor plan depending on finishes, views, and other features inside the apartment home.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_158dd448-7c68-46af-a587-9f5d6e94f726",
      "question": "How can I refer a friend?",
      "answer": "If you love living here and want to refer a friend, please let our office know! We offer resident referral programs throughout the year and would love for your friends and family to join our community.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_7d05e114-3a72-4e46-99ba-8dba832b16c9",
      "question": "What is the application fee and is it refundable?",
      "answer": "Application fees are due for each person 18 and older occupying the apartment. All application fees are nonrefundable.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_5b43f40b-13d8-49f0-9a04-773e3da36927",
      "question": "What is a holding deposit or earnest money?",
      "answer": "A \"holding\" deposit or \"earnest money\" is another word for \"security\" deposit. Please <a href=\"/contact-us\">contact our leasing office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_cf813495-5569-49f8-8c61-770df46f91ac",
      "question": "What utilities am I responsible to pay?",
      "answer": "Our residents are responsible to pay for water, electric and gas.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_72a7d374-581f-4288-8b8c-4107f17b499c",
      "question": "Do you require renters insurance?",
      "answer": "All residents are required to maintain a minimum of $100,000 in liability coverage as part of their lease agreement. For more details on coverage requirements and available options, please <a href=\"/contact-us\">contact our leasing office</a>.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_7087e0d2-b7dd-464c-98d4-badf779dc884",
      "question": "How can I pay my rent?",
      "answer": "You can pay rent by accessing your <a href=\"/resident-access\">resident online account</a>. This allows you to use a bank account or credit card to make payments.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_5e72a961-a91c-42a9-8d15-70ee27fe75e7",
      "question": "Do you offer flexible rent payment options?",
      "answer": "Yes! We’ve partnered with Flex to make paying rent easier for our residents. Flex allows you to split your rent into smaller, more manageable payments throughout the month, giving you added financial flexibility. For more details or to sign up, <a href=\"/contact-us\">contact our leasing office</a> today!",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_f617cb08-f46c-4040-bb50-56fda393f464",
      "question": "Do you offer covered parking?",
      "answer": "Yes, we offer enclosed garages under each building. Please <a href=\"/contact-us\">contact the office</a> for our most current availability and pricing.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_15ed8310-3c71-4bd2-9ea4-0b96c6231e99",
      "question": "Do you host events at your property?",
      "answer": "Yes, we host events throughout the year with various activities to encourage community camaraderie.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_68d9d7fd-a3f9-4273-949a-d8293df0446c",
      "question": "Do you accept packages on behalf of the residents?",
      "answer": "No, we do not offer this service at this time.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_f0401794-e2ad-48f3-8daa-a15662a5cfbd",
      "question": "If something needs to be repaired in my apartment, how do I report it?",
      "answer": "You may call the office or submit work orders online by accessing your <a href=\"/resident-access\">resident account</a>. All emergency repairs should be reported by <a href=\"/contact-us\">contacting the office</a>. If the emergency is being reported after business hours, please follow the prompts to be connected to the answering service.",
      "category": "Maintenance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0c9ac-2b01-72e9-be24-5e6f5d5bea0d",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Cloverset Valley Apartments Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593"
    },
    {
      "lead_collector_id": "01a0c9ac-2bf8-7797-89d1-47d17b3083e4",
      "lead_source": "LANDING_PAGE",
      "name": "Cloverset Valley Apartments Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "generator",
      "page_item_url": "luxury-apartments-fitness-center-kansas-city",
      "search_query": "luxury apartments with fitness center in kansas city mo",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Fitness Center",
      "h2_subtitle": "Discover luxury living in South Kansas City. Our exclusive apartments offer access to a state-of-the-art fitness center.",
      "page_copy": "Discover unparalleled comfort and style at Cloverset Valley Apartments, where luxury meets convenience in Kansas City, MO. Nestled in the serene Country Lane Estates neighborhood, our smoke-free community features gated entry and beautifully landscaped grounds. Enjoy spacious one- and two-bedroom layouts with private balconies and large eat-in kitchens, designed with your lifestyle in mind. Beyond the comforts of home, residents can access a modern fitness center in our elegant Clubhouse, perfect for maintaining an active lifestyle without leaving your community. Experience the perfect blend of luxury and location by scheduling a tour today. Cloverset Valley Apartments is your gateway to a relaxing, yet vibrant South Kansas City experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and tennis court at an apartment complex.",
        "public_id": "019fc928-73da-77be-8128-5cbc4ace9fe0",
        "storage_key": "property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Fitness Center in KC MO",
      "seo_description": "Experience luxury living at Cloverset Valley, with access to a fitness center in Kansas City, MO. Spacious layouts in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "generator",
      "page_item_url": "gated-community-apartments-jackson-county",
      "search_query": "gated community apartments near jackson county",
      "category": "Amenity",
      "h1_title": "Gated Community Apartments near Jackson County",
      "h2_subtitle": "Explore gated community living near Jackson County. Cloverset Valley offers serene living in South Kansas City.",
      "page_copy": "Welcome to Cloverset Valley Apartments, where tranquility meets modern living in a secure gated community near Jackson County. Located in the peaceful Country Lane Estates neighborhood, our community offers the perfect retreat from the hustle and bustle of Kansas City. With picturesque, landscaped grounds, you can enjoy a breath of fresh air in a smoke-free environment. Our one- and two-bedroom apartments feature expansive layouts with private balconies and large kitchens, ideal for anyone seeking comfort and convenience. The elegance of our clubhouse and the connectivity of our eat-in kitchens make coming home a pleasure. Embrace living in a gated community where relaxation and accessibility coalesce effortlessly. Visit Cloverset Valley today to experience the best South Kansas City has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and tennis court at an apartment complex.",
        "public_id": "019fc928-73da-77be-8128-5cbc4ace9fe0",
        "storage_key": "property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Community Apartments in KC near Jackson County",
      "seo_description": "Discover gated community living at Cloverset Valley near Jackson County. Spacious apartments with private balconies in South Kansas City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "generator",
      "page_item_url": "spacious-apartments-private-balconies-country-lane",
      "search_query": "spacious apartments with private balconies in country lane estates",
      "category": "Amenity",
      "h1_title": "Spacious Apartments with Private Balconies",
      "h2_subtitle": "Live in spacious comfort in Country Lane Estates. Enjoy the luxury of private balconies in our beautiful apartments.",
      "page_copy": "Cloverset Valley Apartments offers a welcoming retreat in the heart of Country Lane Estates, featuring spacious apartments designed with you in mind. Each one- and two-bedroom layout boasts private balconies where you can unwind and enjoy the serene South Kansas City skyline. Situated within gated grounds, our smoke-free community provides a peaceful, yet connected living experience, complete with large kitchens perfect for entertaining and everyday convenience. Imagine sipping morning coffee on your balcony while surrounded by beautiful landscaping, or gathering with friends in our modern clubhouse. Experience the perfect blend of seclusion and accessibility at Cloverset Valley Apartments today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and tennis court at an apartment complex.",
        "public_id": "019fc928-73da-77be-8128-5cbc4ace9fe0",
        "storage_key": "property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Apartments with Balconies in Country Lane",
      "seo_description": "Discover spacious apartments with private balconies in Country Lane Estates. Experience relaxed living at Cloverset Valley Apartments.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "generator",
      "page_item_url": "apartments-swimming-pool-cabana-kansas-city",
      "search_query": "apartments with swimming pool and cabana kansas city",
      "category": "Amenity",
      "h1_title": "Apartments with Pool and Cabana in KC",
      "h2_subtitle": "Relax in style with poolside comforts. Our Kansas City apartments offer all the amenities you need.",
      "page_copy": "Dive into luxury at Cloverset Valley Apartments, offering a relaxing lifestyle in vibrant Kansas City, MO. While our community shines with amenities, such as a modern Clubhouse and eat-in kitchens, residents particularly enjoy lounging by the sparkling swimming pool. Complete with an inviting cabana, it's the perfect spot to unwind and bask in the sun. Situated in the peaceful neighborhood of Country Lane Estates, our gated community features large one- and two-bedroom apartments that welcome you with private balconies and expansive living spaces. Discover the ultimate blend of comfort and entertainment by making Cloverset Valley your new home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and tennis court at an apartment complex.",
        "public_id": "019fc928-73da-77be-8128-5cbc4ace9fe0",
        "storage_key": "property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool & Cabana in Kansas City",
      "seo_description": "Enjoy poolside living with a cabana at Cloverset Valley in Kansas City. Spacious apartments and luxury amenities await you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "generator",
      "page_item_url": "apartments-stainless-steel-appliances-jackson-county",
      "search_query": "apartments with stainless steel appliances jackson county",
      "category": "Amenity",
      "h1_title": "Apartments with Stainless Steel Appliances",
      "h2_subtitle": "Modern living with stainless steel appliances near Jackson County. Experience convenience at Cloverset Valley Apartments.",
      "page_copy": "Experience contemporary living at Cloverset Valley Apartments, where sleek stainless steel appliances complement our thoughtful designs near Jackson County. Nestled in the tranquil Country Lane Estates neighborhood, our spacious one- and two-bedroom apartments offer more than just living space—they provide a lifestyle. Enjoy the comforts of a large kitchen complete with modern fittings, perfect for culinary enthusiasts. The beauty of private balconies adds a serene outdoor touch, while our smoke-free, gated community ensures peace of mind. Explore the perfect mix of style and function that awaits you at Cloverset Valley, setting the standard for apartment living in South Kansas City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and tennis court at an apartment complex.",
        "public_id": "019fc928-73da-77be-8128-5cbc4ace9fe0",
        "storage_key": "property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts with Stainless Steel Appliances Near Jackson County",
      "seo_description": "Discover stainless steel appliances in spacious apartments at Cloverset Valley near Jackson County. Modern living in South Kansas City awaits you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-south-kansas-city",
      "search_query": "one bedroom apartments south kansas city",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in South KC",
      "h2_subtitle": "Comfortable one-bedroom living in South Kansas City. Discover the charm of Cloverset Valley Apartments today.",
      "page_copy": "Find your perfect home at Cloverset Valley Apartments, where our thoughtfully designed one-bedroom layouts provide the ideal balance of comfort and style in South Kansas City. Surrounded by the tranquil scenery of Country Lane Estates, each apartment comes with a private balcony, offering a personal retreat from the bustle of city life. Enjoy spacious interiors, including an eat-in kitchen that's functional and inviting, all within a smoke-free and gated community. Our array of amenities, coupled with the convenient location, make Cloverset Valley an unbeatable choice for those seeking the best of Kansas City living without sacrificing peace and quiet. Schedule a tour and see why our residents love calling Cloverset Valley home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and tennis court at an apartment complex.",
        "public_id": "019fc928-73da-77be-8128-5cbc4ace9fe0",
        "storage_key": "property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in South Kansas City",
      "seo_description": "Explore one-bedroom apartments at Cloverset Valley in South Kansas City. Enjoy spacious layouts and a peaceful community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-country-lane-estates",
      "search_query": "two bedroom apartments country lane estates",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Country Lane Estates",
      "h2_subtitle": "Spacious two-bedroom apartments located in the serene Country Lane Estates. Discover Cloverset Valley living.",
      "page_copy": "Settle into Cloverset Valley Apartments, where expansive two-bedroom layouts redefine comfort and convenience in the peaceful Country Lane Estates. Our apartments feature private balconies and thoughtfully designed spaces ideal for both relaxation and entertainment. Nestled within a gated community, these smoke-free residences are equipped with large kitchens, perfect for hosting and culinary creations. Beyond the apartment doors, residents enjoy access to a modern Clubhouse and lush landscaped surroundings. Discover the charm of South Kansas City while relishing the tranquility of Country Lane Estates—come by for a visit and see how Cloverset Valley can be the perfect home for you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and tennis court at an apartment complex.",
        "public_id": "019fc928-73da-77be-8128-5cbc4ace9fe0",
        "storage_key": "property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apts in Country Lane Estates",
      "seo_description": "Discover spacious two-bedroom apartments at Cloverset Valley, located in the serene Country Lane Estates, South Kansas City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "generator",
      "page_item_url": "apartments-near-red-bridge-elementary-country-lane-estates",
      "search_query": "apartments near Red Bridge Elementary School Country Lane Estates",
      "category": "School",
      "h1_title": "Apartments Near Red Bridge Elementary",
      "h2_subtitle": "Conveniently located near Red Bridge Elementary, Cloverset Valley offers family-friendly living in Country Lane Estates.",
      "page_copy": "Welcome to Cloverset Valley Apartments, where family-friendly living meets ideal location near Red Bridge Elementary School in the charming Country Lane Estates. Our one- and two-bedroom apartments provide not only comfort and space but also a strategic proximity to quality education. Residents enjoy access to spacious interiors, complete with large kitchens and optional den/study spaces, perfect for growing families. Situated within a secure, gated community, these smoke-free apartments offer private balconies and a welcoming Clubhouse for recreation and social events. Discover the perks of community-centered living while keeping convenience and a quality lifestyle at the forefront in South Kansas City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and tennis court at an apartment complex.",
        "public_id": "019fc928-73da-77be-8128-5cbc4ace9fe0",
        "storage_key": "property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Red Bridge Elementary",
      "seo_description": "Find comfortable living at Cloverset Valley near Red Bridge Elementary in Country Lane Estates, ideal for families in South Kansas City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "generator",
      "page_item_url": "cloverset-valley-apts-near-indian-creek-elementary",
      "search_query": "Cloverset Valley apts close to Indian Creek Elementary School",
      "category": "School",
      "h1_title": "Cloverset Valley Apts Near Indian Creek Elementary",
      "h2_subtitle": "Discover the convenience of living at Cloverset Valley Apartments near Indian Creek Elementary School in South Kansas City.",
      "page_copy": "Experience the ideal blend of location and lifestyle at Cloverset Valley Apartments, conveniently close to Indian Creek Elementary School. Our picturesque community in South Kansas City's Country Lane Estates offers spacious one- and two-bedroom apartments perfect for families seeking proximity to quality education. With features like private balconies and roomy kitchens, you'll find plenty of space for daily living and entertaining. As a resident, you'll enjoy a smoke-free environment, secure gated access, and a welcoming Clubhouse, all within a peaceful, landscaped setting. Embrace the community spirit and convenience offered by Cloverset Valley Apartments, and enjoy the benefit of being near the respected Indian Creek Elementary.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and tennis court at an apartment complex.",
        "public_id": "019fc928-73da-77be-8128-5cbc4ace9fe0",
        "storage_key": "property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Indian Creek Elementary School",
      "seo_description": "Live at Cloverset Valley, close to Indian Creek Elementary in South KC. Enjoy a family-friendly community with spacious living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "generator",
      "page_item_url": "apartments-near-center-middle-school-kc",
      "search_query": "apartments near Center Middle School Kansas City",
      "category": "School",
      "h1_title": "Apartments Near Center Middle School KC",
      "h2_subtitle": "Cloverset Valley offers ideal living just minutes from Center Middle School in the vibrant South Kansas City area.",
      "page_copy": "Discover a harmonious blend of comfort and convenience at Cloverset Valley Apartments, strategically located near Center Middle School. Set in the tranquil surroundings of South Kansas City's Country Lane Estates, our one- and two-bedroom apartments cater to families and professionals seeking proximity to excellent schools and community amenities. Enjoy a spacious layout complete with eat-in kitchens and private balconies, ideal for everyday living. The gated community ensures safety, while the smoke-free environment promotes health and wellness. With a Clubhouse for socializing and landscaped grounds, Cloverset Valley lets you savor the best of apartment living just a stone's throw from Center Middle School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and tennis court at an apartment complex.",
        "public_id": "019fc928-73da-77be-8128-5cbc4ace9fe0",
        "storage_key": "property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Center Middle School Kansas City",
      "seo_description": "Find spacious apartments at Cloverset Valley near Center Middle School in South Kansas City. Enjoy convenient and family-friendly living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "generator",
      "page_item_url": "boone-elementary-school-nearby-apartments-mo",
      "search_query": "Boone Elementary School nearby apartments in MO",
      "category": "School",
      "h1_title": "Nearby Apartments to Boone Elementary MO",
      "h2_subtitle": "Cloverset Valley offers convenient living near Boone Elementary School, nestled in the heart of South Kansas City, MO.",
      "page_copy": "Enjoy a seamless blend of convenience and lifestyle at Cloverset Valley Apartments, ideally located near Boone Elementary School in the vibrant South Kansas City area. Our well-appointed one- and two-bedroom homes provide the perfect setting for families who prioritize education and community living. Features such as eat-in kitchens and private balconies enhance daily living, while amenities like a welcoming Clubhouse and secure gated access ensure peace of mind. Situated in the Country Lane Estates neighborhood, Cloverset Valley Apartments invite you to explore a relaxing, smoke-free environment within easy reach of Boone Elementary School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and tennis court at an apartment complex.",
        "public_id": "019fc928-73da-77be-8128-5cbc4ace9fe0",
        "storage_key": "property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Boone Elementary School MO",
      "seo_description": "Explore Cloverset Valley Apartments near Boone Elementary in MO. Enjoy family-friendly living in South Kansas City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "generator",
      "page_item_url": "apartments-close-to-yellowjacket-early-learning-64114",
      "search_query": "apartments close to Yellowjacket Early Learning Center 64114",
      "category": "School",
      "h1_title": "Apt Close to Yellowjacket Early Learning 64114",
      "h2_subtitle": "Find the ideal home at Cloverset Valley Apartments, located conveniently close to Yellowjacket Early Learning Center in zip code 64114.",
      "page_copy": "Cloverset Valley Apartments offers an inviting community for families looking to be near Yellowjacket Early Learning Center in the zip code 64114 area. Nestled in South Kansas City's tranquil Country Lane Estates, our spacious one- and two-bedroom apartments provide ample room with features like large kitchens and private balconies. Parents will appreciate the convenience of living close to an early learning center, complemented by our smoke-free environment and gated safety. With amenities like a cozy Clubhouse, Cloverset Valley Apartments ensure a blend of comfort and convenience, making it a perfect choice for those prioritizing proximity to quality education.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and tennis court at an apartment complex.",
        "public_id": "019fc928-73da-77be-8128-5cbc4ace9fe0",
        "storage_key": "property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Yellowjacket Early Learning, 64114",
      "seo_description": "Discover Cloverset Valley Apartments, near Yellowjacket Early Learning Center in 64114. Ideal family-friendly living in South Kansas City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "generator",
      "page_item_url": "apartments-near-notre-dame-de-sion-high-jackson",
      "search_query": "apartments near Notre Dame de Sion High School Jackson County",
      "category": "School",
      "h1_title": "Apartments Near Notre Dame de Sion High, Jackson",
      "h2_subtitle": "Cloverset Valley Apartments offer convenient living near Notre Dame de Sion High School in Jackson County, blending education with comfort.",
      "page_copy": "Experience the perfect blend of convenience and community at Cloverset Valley Apartments, conveniently situated near Notre Dame de Sion High School in Jackson County. Our well-designed one- and two-bedroom apartments provide an engaging environment ideal for students and families who value proximity to quality education. Enjoy modern amenities such as eat-in kitchens, private balconies, and a secure gated entrance, while residing in a picturesque, landscaped setting. Located in South Kansas City's Country Lane Estates, Cloverset Valley offers a welcoming, smoke-free community complemented by a vibrant Clubhouse, perfect for socializing and relaxation.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and tennis court at an apartment complex.",
        "public_id": "019fc928-73da-77be-8128-5cbc4ace9fe0",
        "storage_key": "property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Notre Dame de Sion High Jackson MO",
      "seo_description": "Find comfortable living at Cloverset Valley, near Notre Dame de Sion High School in Jackson County. Ideal for families seeking quality education nearby.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "generator",
      "page_item_url": "cloverset-valley-apartments-near-umkc",
      "search_query": "Cloverset Valley apartments near University of Missouri-Kansas City",
      "category": "School",
      "h1_title": "Cloverset Valley Apts Near UMKC",
      "h2_subtitle": "Live at Cloverset Valley Apartments, conveniently located near the University of Missouri-Kansas City, offering an ideal home for students and staff.",
      "page_copy": "Discover the perfect balance of tranquility and convenience at Cloverset Valley Apartments, located a short drive from the University of Missouri-Kansas City. Our spacious one- and two-bedroom layouts, complete with eat-in kitchens and private balconies, cater perfectly to both students and university staff. Nestled in South Kansas City's quiet Country Lane Estates neighborhood, Cloverset Valley ensures a peaceful environment enhanced by gated security and a smoke-free policy. The community's welcoming Clubhouse offers a great spot for relaxation or study sessions, making it an ideal home base near UMKC.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and tennis court at an apartment complex.",
        "public_id": "019fc928-73da-77be-8128-5cbc4ace9fe0",
        "storage_key": "property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cloverset Valley Apts Near UMKC",
      "seo_description": "Explore comfortable living at Cloverset Valley Apartments near the University of Missouri-Kansas City. Ideal for students and staff.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "generator",
      "page_item_url": "apartments-near-research-medical-center-kc",
      "search_query": "apartments near Research Medical Center Kansas City",
      "category": "Hospital",
      "h1_title": "Apts Near Research Medical Center KC",
      "h2_subtitle": "Discover the convenience of living at Cloverset Valley Apartments near Research Medical Center in Kansas City, combining comfort with location.",
      "page_copy": "Cloverset Valley Apartments provide a serene yet convenient living choice for those seeking proximity to Research Medical Center in Kansas City. Our spacious one- and two-bedroom options, featuring private balconies and expansive kitchens, create a comfortable home base close to essential healthcare facilities. Located in the peaceful Country Lane Estates neighborhood, Cloverset Valley presents a secure gated community ideal for medical professionals. With amenities including a smoke-free environment and a welcoming Clubhouse, residents enjoy both relaxation and easy access to Kansas City's healthcare hubs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and tennis court at an apartment complex.",
        "public_id": "019fc928-73da-77be-8128-5cbc4ace9fe0",
        "storage_key": "property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Research Medical Center Kansas City",
      "seo_description": "Choose Cloverset Valley Apartments for comfortable living near Research Medical Center in Kansas City. Perfect for healthcare professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "generator",
      "page_item_url": "university-health-truman-medical-jackson-co-apts",
      "search_query": "University Health Truman Medical Center nearby Jackson County apartments",
      "category": "Hospital",
      "h1_title": "Apts Near University Health Truman Medical",
      "h2_subtitle": "Discover Cloverset Valley Apartments, offering comfortable living near University Health Truman Medical Center, right in Jackson County.",
      "page_copy": "For those working or studying at University Health Truman Medical Center, Cloverset Valley Apartments in Jackson County offer a blend of peace and convenience. Situated within reach of the medical center, our one-and two-bedroom residences boast spacious interiors, private balconies, and fully equipped eat-in kitchens, ensuring a comfortable lifestyle near your workplace. As part of the serene South Kansas City’s Country Lane Estates, our community provides secure, gated living with smoke-free facilities, perfect for busy professionals looking to unwind after a long day. Enjoy a vibrant community atmosphere, complete with a welcoming Clubhouse.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and tennis court at an apartment complex.",
        "public_id": "019fc928-73da-77be-8128-5cbc4ace9fe0",
        "storage_key": "property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near University Health Truman Medical Center MO",
      "seo_description": "Comfortable living awaits at Cloverset Valley, near University Health Truman Medical Center in Jackson County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "generator",
      "page_item_url": "childrens-mercy-adele-hall-close-64114-apts",
      "search_query": "Children's Mercy Adele Hall Campus close 64114 apartments",
      "category": "Hospital",
      "h1_title": "Apts Close to Children's Mercy Adele Hall",
      "h2_subtitle": "Explore Cloverset Valley Apartments, conveniently located close to Children's Mercy Adele Hall Campus, in the vibrant 64114 area.",
      "page_copy": "Cloverset Valley Apartments offers a perfect location for professionals and families seeking a home close to Children's Mercy Adele Hall Campus within the 64114 area. Our well-designed one- and two-bedroom apartments feature spacious eat-in kitchens and serene private balconies, providing a comfortable retreat near the hospital. Nestled in the tranquil Country Lane Estates neighborhood of South Kansas City, our gated, smoke-free community promotes a harmonious living environment. The Clubhouse adds a social element, making it easy to connect with neighbors while staying close to key facilities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and tennis court at an apartment complex.",
        "public_id": "019fc928-73da-77be-8128-5cbc4ace9fe0",
        "storage_key": "property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Children's Mercy Adele Hall Campus",
      "seo_description": "Live near Children's Mercy Adele Hall Campus at Cloverset Valley Apartments in Kansas City's 64114 area. Ideal for healthcare staff and families.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "generator",
      "page_item_url": "apartments-near-watts-mill-park-kansas-city",
      "search_query": "apartments near Watts Mill Park Kansas City",
      "category": "Park",
      "h1_title": "Apts Near Watts Mill Park KC",
      "h2_subtitle": "Find your home at Cloverset Valley Apartments, located near the scenic Watts Mill Park in Kansas City's peaceful southern area.",
      "page_copy": "Nestled close to the serene Watts Mill Park, Cloverset Valley Apartments in Kansas City offer an ideal living solution for nature enthusiasts seeking a tranquil environment with modern conveniences. Featuring spacious one- and two-bedroom layouts, our apartments boast private balconies and large kitchens, perfect for relaxation and entertainment. Situated in the scenic Country Lane Estates neighborhood, Cloverset Valley provides a smoke-free, gated community complemented by a welcoming Clubhouse. Enjoy easy access to the natural beauty of Watts Mill Park while residing in comfort and style in South Kansas City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and tennis court at an apartment complex.",
        "public_id": "019fc928-73da-77be-8128-5cbc4ace9fe0",
        "storage_key": "property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Watts Mill Park in Kansas City",
      "seo_description": "Discover Cloverset Valley, located near Watts Mill Park in KC. Spacious apts with modern amenities in a tranquil setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "generator",
      "page_item_url": "cloverset-valley-apts-near-leawood-city-park",
      "search_query": "Cloverset Valley apartments close to Leawood City Park",
      "category": "Park",
      "h1_title": "Cloverset Valley Apts Near Leawood City Park",
      "h2_subtitle": "Experience the best of Cloverset Valley Apartments, conveniently located close to Leawood City Park, offering serene living near vibrant outdoor spaces.",
      "page_copy": "Cloverset Valley Apartments provides the perfect balance of comfort and accessibility, located close to the beautiful Leawood City Park. Our community in South Kansas City's Country Lane Estates neighborhood allows residents to enjoy spacious one- and two-bedroom living spaces with private balconies and modern eat-in kitchens. Designed for those who appreciate proximity to parks, our gated, smoke-free community offers easy access to outdoor activities while maintaining a peaceful living atmosphere. Residents can indulge in a vibrant lifestyle with our Clubhouse, adding a social touch to everyday living near scenic Kansas City venues like Leawood City Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and tennis court at an apartment complex.",
        "public_id": "019fc928-73da-77be-8128-5cbc4ace9fe0",
        "storage_key": "property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cloverset Valley Apts Near Leawood City Park",
      "seo_description": "Live at Cloverset Valley, close to Leawood City Park. Enjoy spacious apts with modern amenities in a tranquil yet accessible location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "generator",
      "page_item_url": "kc-apts-near-minor-park",
      "search_query": "Kansas City apartments near Minor Park",
      "category": "Park",
      "h1_title": "Kansas City Apts Near Minor Park",
      "h2_subtitle": "Discover Cloverset Valley Apartments, perfectly situated near Minor Park in Kansas City, offering tranquil living spaces with exceptional amenities.",
      "page_copy": "At Cloverset Valley Apartments, residents enjoy the perfect blend of nature and comfort just minutes from Minor Park in Kansas City. Our inviting one- and two-bedroom apartments feature large kitchens and private balconies that provide a serene setting in the charming Country Lane Estates neighborhood. Ideal for those who appreciate natural surroundings and modern conveniences, our community is gated and smoke-free, ensuring a peaceful atmosphere. With amenities like a welcoming Clubhouse and proximity to Minor Park, Cloverset Valley offers a lifestyle that embraces both relaxation and outdoor adventure.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and tennis court at an apartment complex.",
        "public_id": "019fc928-73da-77be-8128-5cbc4ace9fe0",
        "storage_key": "property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Kansas City Apts Near Minor Park",
      "seo_description": "Live at Cloverset Valley, near Minor Park in KC. Spacious apts with modern amenities, situated in a tranquil, natural setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "generator",
      "page_item_url": "jackson-county-apts-near-swope-park",
      "search_query": "apartments in Jackson County near Swope Park",
      "category": "Park",
      "h1_title": "Apts in Jackson County Near Swope Park",
      "h2_subtitle": "Explore Cloverset Valley Apartments, ideally located in Jackson County, close to the expansive Swope Park, offering modern comforts in serene settings.",
      "page_copy": "Cloverset Valley Apartments in Jackson County provide a harmonious blend of peaceful living and proximity to vibrant outdoor spaces, being conveniently close to Swope Park. Our community features commodious one- and two-bedroom units designed with eat-in kitchens and private balconies, perfect for relaxation and enjoyment in South Kansas City’s Country Lane Estates neighborhood. Enjoy the advantage of living in a gated, smoke-free environment, complete with a supportive Clubhouse that adds to the community's charm. Situated near the green expanses of Swope Park, Cloverset Valley offers an excellent retreat with quick access to recreation and nature.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and tennis court at an apartment complex.",
        "public_id": "019fc928-73da-77be-8128-5cbc4ace9fe0",
        "storage_key": "property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Jackson County Apts Near Swope Park",
      "seo_description": "Discover Cloverset Valley, near Swope Park in Jackson County. Modern apts offering a peaceful lifestyle in a prime, accessible location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "generator",
      "page_item_url": "country-lane-estates-apts-prairie-oak-nature-center",
      "search_query": "Country Lane Estates apartments close to Prairie Oak Nature Center",
      "category": "Park",
      "h1_title": "Country Lane Estates Apts by Prairie Oak",
      "h2_subtitle": "Cloverset Valley Apartments in Country Lane Estates offer serene living, close to Prairie Oak Nature Center, blending comfort with nature.",
      "page_copy": "Nestled in the tranquil Country Lane Estates, Cloverset Valley Apartments provide a serene retreat close to Prairie Oak Nature Center. Each of our spacious one- and two-bedroom apartments is designed with large eat-in kitchens and private balconies, creating a comfortable living environment in South Kansas City. The gated and smoke-free community ensures a peaceful lifestyle, complemented by amenities like a welcoming Clubhouse. With Prairie Oak Nature Center nearby, residents have the perfect opportunity to explore nature trails and enjoy outdoor activities, making Cloverset Valley ideal for those looking to balance modern living with natural beauty.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and tennis court at an apartment complex.",
        "public_id": "019fc928-73da-77be-8128-5cbc4ace9fe0",
        "storage_key": "property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Country Lane Estates Apts by Prairie Oak",
      "seo_description": "Live at Cloverset Valley, near Prairie Oak Nature Center. Spacious apartments in Country Lane Estates offering a blend of comfort and nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167593",
      "source": "generator",
      "page_item_url": "apts-near-kansas-city-international-airport",
      "search_query": "apartments near kansas city international airport",
      "category": "Transit",
      "h1_title": "Apts Near Kansas City Intl Airport",
      "h2_subtitle": "Discover Cloverset Valley Apartments, a short drive from Kansas City International Airport, offering convenience and comfort in a serene setting.",
      "page_copy": "Experience the best of both worlds at Cloverset Valley Apartments, located a convenient drive from Kansas City International Airport. Our community in South Kansas City's Country Lane Estates offers airy one- and two-bedroom apartments with features like expansive eat-in kitchens and private balconies, ensuring a comfortable living experience. Enjoy the benefits of a gated, smoke-free environment, complemented by our Clubhouse amenity that fosters a sense of community. The proximity to the airport makes Cloverset Valley ideal for frequent travelers who value both accessibility and a peaceful home environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and tennis court at an apartment complex.",
        "public_id": "019fc928-73da-77be-8128-5cbc4ace9fe0",
        "storage_key": "property/6767906449167593/019fc928-73da-77be-8128-5cbc4ace9fe0.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Kansas City Intl Airport",
      "seo_description": "Conveniently located near Kansas City Intl Airport, Cloverset Valley offers spacious, comfortable apts in a peaceful setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12701847965"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MZFSLVW4"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Batch 6"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Rise"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/76b076af-7299-4514-bc20-c73195767093/app.js?nocache=1&gaTracking=G-GXEGYEEJ71&buttonbgcolor=b47e00&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "816-320-6292"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImVGWnBWcHFHYUhQS0o1Qk1PTTNCeFE9PSIsInZhbHVlIjoicmtBWjdPdjFDbXhodmNGUXNPK2NpUT09IiwibWFjIjoiODQyY2Y3NTNkNDRlODFiM2RhYzgxMjBhZTYzYWRhMDQxZmQzYWM5Yjc0YzQwYWRkMTZhOTk0MDU2OGUwOTNhOSJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "12701847965",
  "custom_google_gtm_id": "GTM-MZFSLVW4",
  "custom_rollout_phase": "Batch 6",
  "custom_vibesites_theme": "Rise",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/76b076af-7299-4514-bc20-c73195767093/app.js?nocache=1&gaTracking=G-GXEGYEEJ71&buttonbgcolor=b47e00&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>",
  "custom_seo_subscription": "essential",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "816-320-6292",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImVGWnBWcHFHYUhQS0o1Qk1PTTNCeFE9PSIsInZhbHVlIjoicmtBWjdPdjFDbXhodmNGUXNPK2NpUT09IiwibWFjIjoiODQyY2Y3NTNkNDRlODFiM2RhYzgxMjBhZTYzYWRhMDQxZmQzYWM5Yjc0YzQwYWRkMTZhOTk0MDU2OGUwOTNhOSJ9",
  "custom_audioeye_site_id": "e0205ac4-fa69-4eab-b023-d550cec56cd2",
  "custom_audioeye_site_hash": "e963ae24611c4db2a7347cbc8d01aa4e"
};

export const generatedAt = '2026-11-03T23:01:33.865Z';
